import React, { useState, useEffect, useCallback, useMemo, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Render, FieldLabel, DropZone } from "@measured/puck";
import { performHttpRequest } from '../../../common/performHttpRequest';
import Svg from '../../../common/Svg';
import './styles/style.css';
import { Link } from 'react-router-dom';
import ReactEcharts from "echarts-for-react";
import Range from "./Range";
import { ToastContainer, toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import Logo from './images/Logo';
import axios from 'axios';
import logo_fallback from "../../../assets/images/logo-fallback.svg";


const apiUrl = process.env.REACT_APP_NODE_API_URL;

const changeModal = () => {
  //console.log("handle click ");
  //setHandleModalOpen(true);
};


// const ROIReportSubmitted = () => {

// };

// export default ROIReportSubmitted;

const StoreROI = () => {

  const { roiId, submittedID } = useParams();
  const masterId = submittedID;


  const [isLoading, setIsLoading] = useState(true);
  const [pages, setPages] = useState([]);
  const [editorData, setEditData] = useState(null);
  const [reportPages, setReportPages] = useState([]);
  const [currentReportId, setCurrentReportId] = useState()
  // const [configObject, setConfigObject] = useState(config)
  const [roiName, setRoiName] = useState("");
  const [roipageshow, setroipageshow] = useState([]);
  const [isIdPresent, setIsIdPresent] = useState(false);
  const [renderData, setRenderData] = useState(null);
  const [renderModalData, setRenderModalData] = useState(null);


  const [allCondtionalLogicData, setAllConditionalLogicData] = useState([]);
  const [allActionData, setAllActionData] = useState([])
  const [currentPageId, setCurrentPageId] = useState(null);
  const [currentPopupPageId, setCurrentPopupPageId] = useState(null);
  const [popupStatus, setPopupStatus] = useState(false);
  const [roipages, setRoipages] = useState({});
  const [roiVariableData, setRoiVaiableData] = useState({});
  const [roiActionArr, setRoiActionArr] = useState({});
  const [roiFlag, setRoiFlag] = useState(false);
  const [language, setLanguage] = useState('');
  const [currency, setCurrency] = useState([]);
  const [defaultCurrency, setDefaultCurrency] = useState('GBP');
  const [changedCurrency, setChangedCurrency] = useState('');
  const [currencySymbol, setCurrencySymbol] = useState('');
  const [exchangeRate, setExchangeRate] = useState('');
  const [locale, setLocale] = useState('');
  const [globalRoiArr, setGlobalRoiArr] = useState([]);
  const [changedDropdown, setChangedDropdown] = useState([]);

  const [PageActionArr, setpageActionArr] = useState({});

  const [reportrender, setReportrender] = useState([]);

  const [selectedCompany, setSelectedCompany] = useState('microsoft');
  const [selectedYear, setSelectedYear] = useState('year1');

  //const [PieChartData, setPieChartData] = useState([]);

  const PieChartData = useRef([]);

  const [PieChartDataMS, setPieChartDataMS] = useState([]);
  const [PieChartDataVBUC, setPieChartDataVBUC] = useState([]);

  const CurrencyFormatter = ({ amount }) => {
    const formattedAmount = amount.toLocaleString({
      style: 'currency',
      // currency: changedCurrency == '' ? defaultCurrency : changedCurrency,
      currency: currency == '' ? defaultCurrency : currency,
    });
    //console.log("formattedAmount",formattedAmount)
    return formattedAmount;
  };



  const pieEChart = (items, title, subtext) => {
    //console.log('items chart', items);

    let totalValue = 0;

    items = PieChartData.current[0];
    //console.log('items chart', PieChartData.current);  


    for (let i = 0; i < items.length; i++) {
      totalValue += parseFloat(items[i].value);
    }

    // Transform items to match the required series data format
    const seriesData = items.map((item) => ({
      value: parseFloat(item.value), // Convert value to a number if it's a string
      name: item.Text,
    }));

    // Extract colors from items
    //const colors = items.map((item) => item.Color);
    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "item",
        formatter: "{b}: {c} ({d}%)", // Shows name, value, and percentage
      },
      legend: {
        orient: "horizontal",
        left: "center",
        bottom: "0", // Adjust as needed for vertical position
        data: legend, // Matches the names in series.data
        itemGap: 50, // Space between legend items
        itemWidth: 15, // <--- ADD THIS: Width of the colored box (e.g., 15 pixels)
        itemHeight: 15, // <--- ADD THIS: Height of the colored box (e.g., 15 pixels)
      },
      animation: false, // or false if you want to disable all animations
      animationDuration: 0,
      animationDurationUpdate: 0,
      animationEasing: 'linear',
      // title is used for the text in the center of the donut
      title: {
        text: title, // The main number
        subtext: totalValue, // The text below the number
        left: "center",
        top: "42%", // Position in the middle of the chart

        textStyle: {
          fontSize: 14, // Adjust font size for "Total Licenses"
          fontWeight: "normal",
          color: "#666", // Adjust color as needed
        },
        subtextStyle: {
          fontSize: 36, // Adjust font size for "450"
          fontWeight: "bold",
          color: "#333", // Adjust color as needed
        },
      },
      series: [
        {

          type: "pie",
          // To make it a donut chart, radius is an array: [innerRadius, outerRadius]
          // Adjust these percentages for the desired thickness of the donut
          radius: ["40%", "75%"],
          center: ["50%", "50%"], // Ensure chart is centered if title is also centered
          avoidLabelOverlap: false, // Important for custom label positioning
          //color: colors, // Purple, Orange, Teal
          color: ["#00B0CA", "#EB9700", "#9C2AA0"], // Purple, Orange, Teal
          data: seriesData,
          label: {
            show: true,
            position: "outside",
            formatter: "{c}", // Show the value (count) on the label
            color: "#333", // Label text color
            fontSize: 12,
            // distanceToLabelLine: 5, // Optional: adjust space between label and line start
          },
          labelLine: {
            show: true,
            length: 15, // Length of the first part of the line
            length2: 10, // Length of the second part of the line (after the jog)
            smooth: false, // Use straight lines
          },
          emphasis: {
            // Style when hovering over a slice
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: "rgba(0, 0, 0, 0.3)",
            },
            label: {
              // Optional: make label more prominent on hover
              show: true,
              fontSize: "14",
              fontWeight: "bold",
            },
          },
          // The `top` property from your original series is removed as `center` and `title` positioning handles it.
        },
      ],
      // The `grid` option is generally not needed for pie charts, but keeping it won't harm.
      // You can remove it if you prefer.
      grid: {
        left: "5%", // Adjusted to give more space if labels are long
        right: "5%",
        bottom: "15%", // Ensure space for the legend
        containLabel: true,
      },
    };
  };


  const barEChart = (items, title, subtext) => {

    items = PieChartData.current[1];
    // Prepare series
    const series = items.map((item) => ({
      name: item.Text,
      type: "bar",
      barWidth: 40, // Match BarChartOptions
      data: [parseFloat(item.value)], // Single value per series
      itemStyle: {
        color: item.Color,
        borderRadius: [5, 5, 0, 0], // Match BarChartOptions
      },
      emphasis: { focus: "series" },
      label: {
        show: true,
        position: "top",
        formatter: "{c}",
        color: "#333",
        fontSize: 12,
      },
      // animation: false, // or false if you want to disable all animations
      // animationDuration: 0,
      // animationDurationUpdate: 0,
      // animationEasing: 'linear',
    }));

    const legend = items.map((item) => item.Text);

    return {
      tooltip: {
        trigger: "axis",
        axisPointer: { type: "shadow" },
        // Optionally, use the same formatter as BarChartOptions
      },
      animation: false, // or false if you want to disable all animations
      animationDuration: 0,
      animationDurationUpdate: 0,
      animationEasing: 'linear',
      legend: {
        show: true,
        data: legend,
        bottom: "0",
        left: "center",
        itemGap: 15,
        itemWidth: 12,
        itemHeight: 12,
        icon: "circle",
        textStyle: {
          color: "#595959",
          fontSize: 13,
        },
      },
      grid: {
        left: "3%",
        top: "10%",
        right: "4%",
        bottom: "35%",
        containLabel: true,
      },
      xAxis: [
        {
          type: "category",
          data: [""], // Single group
          axisTick: { show: false },
          axisLine: { show: false },
          axisLabel: { show: false },
        },
      ],
      yAxis: [
        {
          type: "value",
          min: 0,
          // Optionally set max and interval as in BarChartOptions
          axisLabel: {
            color: "#595959",
            fontSize: 14,
          },
          axisLine: { show: false },
          axisTick: { show: false },
          splitLine: {
            show: true,
            lineStyle: {
              type: "dashed",
              color: "#E0E0E0",
            },
          },
        },
      ],
      series,
    };
  };


  useEffect(() => {
    //console.log('roiActionArr========>', roiActionArr);

    // Axios request configuration
    let config = {
      method: 'GET',
      maxBodyLength: Infinity,
      url: `${apiUrl}/roi-submit-data/get`,
      headers: {
        'Content-Type': 'application/json'
      },
    };
    // Perform the Axios request
    axios.request(config)
      .then((response) => {
        // console.log('reponsec_Actionarr', JSON.parse(response.data.data[0].structure));
        // console.log('reponsecr', (response.data));

        setpageActionArr(JSON.parse(response.data.data[0].structure))
        const curecny_value = ((JSON.parse(response.data.data[0].currency_symbol)));
        // console.log(curecny_value, 'currency value')

        setCurrencySymbol(curecny_value["currencySymbol"])
        setCurrency(curecny_value["currency"][0])
        setLocale('en-US')


      })
      .catch((error) => {
        console.error('Error:', error);
      });
  }, []);

  // const CurrencyFormatter = ({ amount }) => {
  //   console.log("Currency value ======>", currency)
  //   const [formattedAmount, setFormattedAmount] = useState('');

  //   useEffect(() => {
  //     const formattedAmount = amount.toLocaleString(locale, {
  //       style: 'currency',
  //       currency: currency
  //     });
  //     setFormattedAmount(formattedAmount);
  //   }, [amount, currency, defaultCurrency]);

  //   return formattedAmount;
  // };

  const OneYearChartOptions = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    grid: {
      left: '30%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    series: [
      {
        name: 'Actual Benefits with Vodafone',
        type: 'pie',
        radius: '50%',
        color: ['#9C2AA0', '#EB9700', '#00B0CA'], // Specify colors for the pie slices here
        data: [
          { value: 1048, name: 'Lower Costs' },
          { value: 735, name: 'Increase Productivity' },
          { value: 580, name: 'Enable Business' },

        ],
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: 'rgba(0, 0, 0, 0.5)'
          }
        }
      }
    ]
  };

  const ThreeYearChartOptions = {
    tooltip: {
      trigger: 'axis',
      axisPointer: {
        type: 'shadow'
      }
    },
    legend: {
      orient: 'vertical',
      left: 'left'
    },
    grid: {
      left: '30%',
      right: '4%',
      bottom: '3%',
      containLabel: true
    },
    xAxis: [
      {
        type: 'category',
        data: ['2022', '2023', '2024']
      }
    ],
    yAxis: [
      {
        type: 'value'
      }
    ],
    series: [

      {
        name: 'Lower Costs',
        type: 'bar',
        stack: 'Ad',
        barWidth: '60',
        emphasis: {
          focus: 'series'
        },
        itemStyle: {
          color: '#9C2AA0' // Apply purple color here
        },
        data: [120, 132, 101, 134, 90, 230, 210]
      },
      {
        name: 'Increase Productivity',
        type: 'bar',
        stack: 'Ad',
        barWidth: '60',
        emphasis: {
          focus: 'series'
        },
        itemStyle: {
          color: '#EB9700' // Apply orange color here
        },
        data: [220, 182, 191, 234, 290, 330, 310]
      },
      {
        name: 'Enable Business',
        type: 'bar',
        stack: 'Ad',
        barWidth: '60',
        emphasis: {
          focus: 'series'
        },
        itemStyle: {
          color: '#00B0CA' // Apply cyan color here
        },
        data: [150, 232, 201, 154, 190, 330, 410]
      },



    ]
  };

  const pieChart = (items) => {



    //console.log('items chart', items);

    // Transform items to match the required series data format
    // const seriesData = items.map(item => ({
    //   value: parseFloat(item.value), // Convert value to a number if it's a string
    //   name: item.Text,
    //   symbol: currencySymbol,
    //   formatted: CurrencyFormatter({ amount: parseFloat(item.value) }),
    // }));

    const seriesData = [
      { value: 1048, name: 'Lower Costs' },
      { value: 735, name: 'Increase Productivity' },
      { value: 580, name: 'Enable Business' },

    ]

    // Extract colors from items
    const colors = ['#9C2AA0', '#EB9700', '#00B0CA'];

    return {
      tooltip: {
        trigger: 'item',
      },
      grid: {
        left: '30%',
        right: '4%',
        bottom: '10%',
        containLabel: true
      },
      series: [
        {
          name: 'Cost savings over yearly vs average',
          type: 'pie',
          radius: '80%',
          color: colors, // Use the extracted colors
          data: seriesData,
          emphasis: {
            itemStyle: {
              shadowBlur: 10,
              shadowOffsetX: 0,
              shadowColor: 'rgba(0, 0, 0, 0.5)'
            }
          }
        }
      ]
    }
  };

  let callCount = 0; // To keep track of function calls




  const chartStyle = {
    height: '200px',
    width: '100%',
  }



  const style = {
    height: '300px',
    width: '100%',
  }

  const handleCompanyChange = (e) => {
    setSelectedCompany(e.target.value);
  };

  const handleYearChange = (e) => {
    setSelectedYear(e.target.value);
  };



  const currencyChange = async (e) => {
    let currency_selected = e.target.value;
    let current_currency = 'USD';
    let current_symbol = '$';
    let exchange_rate = 1;
    let calculated_arr_global = [];
    let updatedRoiActionArr = JSON.parse(JSON.stringify(roiActionArr));

    const response = await fetch(`${apiUrl}/roi-currency/list`);
    const result = await response.json();
    const res = result.data;

    //console.log("ccurrency_selected --exchange rate", currency_selected)

    Object.keys(res).map((key) => {
      if (res[key].currency_name == currency_selected) {
        current_currency = res[key].currency_name;
        exchange_rate = res[key].exchange_rate;
        current_symbol = res[key].symbol;
        //console.log("current_currency", current_currency, exchange_rate);
      }
    })
    // let currency_rate = currencyRates[currency_selected];
    let changedCurrency__ = changedCurrency ? changedCurrency : defaultCurrency;
    //console.log("current_currency --exchange rate", current_currency, exchange_rate, current_symbol, defaultCurrency, changedCurrency)
    if ((changedCurrency__ == 'USD' && changedCurrency__ != current_currency) || (defaultCurrency == 'USD' && changedCurrency__ == '' && current_currency != 'USD')) {
      // console.log("--exchange rate", defaultCurrency + ' ==USD && ' + changedCurrency__ + '=="" && ' + current_currency + '!=USD');
      // console.log("--exchange rate", changedCurrency__ + ' ==USD && ' + changedCurrency__ + '!=' + current_currency);
      await Object.keys(roiActionArr).map((key) => {
        //console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, typeof roiActionArr[key].value)
        if (roiActionArr[key].value != 0 && key != '' && typeof roiActionArr[key].value == 'number' && roiActionArr[key].currency == '1') {
          //console.log("I am in condition 1 ")
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(updatedRoiActionArr[key].value * exchange_rate)
            }
          };
          setRoiActionArr(updatedRoiActionArr)
          // console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, updatedRoiActionArr[key].value)
          calculated_arr_global.push({ variable: key, value: parseFloat(roiActionArr[key].value * exchange_rate).toFixed(0) })
        }
        else if (roiActionArr[key].value != 0 && typeof roiActionArr[key].value == 'string' && key != '' && !isNaN(roiActionArr[key].value) && roiActionArr[key].value !== '' && roiActionArr[key].currency == '1') {
          //console.log("I am in condition 2 ")
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat(parseFloat(updatedRoiActionArr[key].value) * exchange_rate)
            }
          };
          setRoiActionArr(updatedRoiActionArr)
          // console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, updatedRoiActionArr[key].value)
          calculated_arr_global.push({ variable: key, value: parseFloat(parseFloat(roiActionArr[key].value) * exchange_rate).toFixed(0) })
        }
      })

    }

    // console.log("--exchange rate", changedCurrency__ + '!=' + 'USD' + ' && ' + changedCurrency__ + ' != ' + current_currency + ' && ' + changedCurrency__ + '!=' + "''" + exchangeRate + '---' + exchange_rate);
    if (changedCurrency__ != 'USD' && changedCurrency__ != current_currency && changedCurrency__ != '') {
      // console.log("--exchange rate", changedCurrency__ + '!=' + 'USD' + ' && ' + changedCurrency__ + ' != ' + current_currency + ' && ' + changedCurrency__ + '!=' + "''" + exchangeRate + '---' + exchange_rate);
      await Object.keys(roiActionArr).map((key) => {
        if (roiActionArr[key].value != 0 && key != '' && typeof roiActionArr[key].value == 'number' && roiActionArr[key].currency == '1') {
          //console.log("I am in condition 3 ")
          //console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, exchangeRate, exchange_rate, (roiActionArr[key].value / exchangeRate) * exchange_rate)
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: (updatedRoiActionArr[key].value / exchangeRate) * exchange_rate
            }
          };
          setRoiActionArr(updatedRoiActionArr)
          calculated_arr_global.push({ variable: key, value: parseFloat(parseFloat(roiActionArr[key].value / exchangeRate) * exchange_rate).toFixed(0) })

        } else if (roiActionArr[key].value != 0 && typeof roiActionArr[key].value == 'string' && key != '' && !isNaN(roiActionArr[key].value) && roiActionArr[key].value !== '' && roiActionArr[key].currency == '1') {
          //console.log("I am in condition 4 ")
          //console.log("--exchange rate roiActionArr[key].value", key, roiActionArr[key].value, exchangeRate, exchange_rate, (roiActionArr[key].value / exchangeRate) * exchange_rate)
          updatedRoiActionArr = {
            ...updatedRoiActionArr,
            [key]: {
              ...updatedRoiActionArr[key],
              value: parseFloat((parseFloat(updatedRoiActionArr[key].value) / exchangeRate) * exchange_rate)
            }
          };
          setRoiActionArr(updatedRoiActionArr)
          calculated_arr_global.push({ variable: key, value: parseFloat((parseFloat(roiActionArr[key].value) / exchangeRate) * exchange_rate).toFixed(0) })
        }
      })



    }
    setChangedCurrency(current_currency)
    setCurrencySymbol(current_symbol)
    setExchangeRate(exchange_rate)

    //console.log("calculated_arr_global --exchange rate", calculated_arr_global)
    //now create global array and pass it to update all uuid
    await updateValueForRenderAllPages(calculated_arr_global);

  }

  const homeRedirect = () => {
    window.location.reload();
  };

  // For button / link actions on the submitted report
  const onButtonClick = useCallback(
    async (uuid) => {
      // Mark this button as clicked in local roiActionArr (if present)
      if (roiActionArr && roiActionArr[uuid]) {
        const updatedRoiActionArr = {
          ...roiActionArr,
          [uuid]: {
            ...roiActionArr[uuid],
            value: 1,
          },
        };
        setRoiActionArr(updatedRoiActionArr);
      }

      // Prefer metadata from roiActionArr, but fall back to PageActionArr for report pages
      const meta = (roiActionArr && roiActionArr[uuid]) || PageActionArr[uuid] || {};
      const rawAction = meta.actions || meta.action || '';
      const normalizedAction =
        typeof rawAction === 'string' ? rawAction.toLowerCase() : '';

      if (normalizedAction === 'jumptourl') {
        console.log("JumpToUrl action found for uuid:", uuid);
        const link = meta.link || meta.url || meta.href;
        if (link) {
          window.open(link, '_blank', 'noopener,noreferrer');
        } else {
          // eslint-disable-next-line no-console
          console.warn('[ROIReportSubmitted] JumpToUrl action missing link for uuid:', uuid);
        }
      } else if (normalizedAction === 'openpopup') {
        if (meta.action_id) {
          openPopup(meta.action_id);
        } else {
          // eslint-disable-next-line no-console
          console.warn('[ROIReportSubmitted] OpenPopup action missing action_id for uuid:', uuid);
        }
      }
    },
    [roiActionArr, PageActionArr]
  );


  const openPopup = async (id) => {
    try {
      //console.log("PageID-",(roipages[id]))
      //setRenderModalData(JSON.parse(roipages[id]));

      setCurrentPopupPageId(id);
      setPopupStatus(true);

    } catch (error) {
      console.error('Error with GET request:', error);
    }
  }

  const refreshParentPage = async () => {
    setCurrentPopupPageId('');
    setPopupStatus(false);

  }

  const evaluateCondition = (condition, element) => {
    //console.log("evaluateCondition", condition)

    const value = condition['value'] ?? '';
    // console.log("value", value)
    const operator = condition['operator'] ?? '';
    // console.log("operator", operator)
    const value_type = condition['value_type'] ?? '';
    // console.log("value_type", value_type)
    const variable = condition['variable'] ?? '';
    // console.log("variable", variable)
    const variable_data_type = condition['variable_data_type'] ?? '';
    // console.log("variable_data_type", variable_data_type)
    // console.log("roiActionArr[variable].value", roiActionArr[variable].value)
    // console.log(typeof roiActionArr[variable]?.value + "==" + typeof value)
    // console.log(eval(roiActionArr[variable]?.value == value))
    let return__ = false;
    if (roiActionArr[variable]?.value != undefined) {
      switch (operator) {
        case '==':
          return__ = eval(parseFloat(roiActionArr[variable]?.value) == value);
          break;
        case '!=':
          return__ = eval(parseFloat(roiActionArr[variable].value) != value);
          break;
        case '>':
          return__ = eval(parseFloat(roiActionArr[variable].value) > value);
          break;
        case '<':
          return__ = eval(parseFloat(roiActionArr[variable].value) < value);
          break;
        case '>=':
          //console.log('evaluateCondition Cond', roiActionArr[variable].value,value,typeof roiActionArr[variable].value);
          return__ = eval(parseFloat(roiActionArr[variable].value) >= value);
          break;
        case '<=':
          return__ = eval(parseFloat(roiActionArr[variable].value) <= value);
          break;
        case 'is empty':
          return__ = isEmpty(roiActionArr[variable].value);
          break;
        case 'is not empty':
          return__ = !isEmpty(roiActionArr[variable].value);
          break;
        case "is":
          return__ = eval(roiActionArr[variable].value === value);
          break;
        case "is not":
          return__ = eval(roiActionArr[variable].value !== value);
          break;
        case "contains":
          return__ = (roiActionArr[variable].value).includes(value);
          break;
        case "does not contain":
          return__ = !(roiActionArr[variable].value).includes(value);
          break;
        case "starts with":
          return__ = (roiActionArr[variable].value).startsWith(value);
          break;
        case "does not start with":
          return__ = !(roiActionArr[variable].value).startsWith(value);
          break;
        case "ends with":
          return__ = (roiActionArr[variable].value).endsWith(value);
          break;
        case "does not end with":
          return__ = !(roiActionArr[variable].value).endsWith(value);
          break;
        default:
          return__ = false;
      }
      // if (element == 'cfe5d132-b6b0-4a28-a505-c23ea9f4de2b') {



    }
    //console.log("return__", return__)
    return return__;
  };

  const isEmpty = (value) => {
    return (
      value === null ||                          // check for null
      value === undefined ||                     // check for undefined
      value === "" ||                            // check for empty string
      (Array.isArray(value) && value.length === 0) || // check for empty array
      (typeof value === 'object' && value !== null && Object.keys(value).length === 0)  // check for empty object
    );
  }


  const processLogic = async () => {

    let logics = allCondtionalLogicData;
    //console.log("roiActionArr--2", roiActionArr);
    let roiActionArr__ = JSON.parse(JSON.stringify(roiActionArr));

    Object.keys(roiActionArr__).forEach(async (element) => {
      roiActionArr__ = {
        ...roiActionArr__,
        [element]: {
          ...roiActionArr__[element],
          count: 0
        }
      };
    });

    let is_changed = 2;
    let count = 0;
    let calculated_arr_global = [];
    await Object.keys(logics).forEach(async (element, index) => {
      //  console.log("element",element)
      await Object.keys(logics[element]).forEach(async (element1, index1) => {
        // console.log(element1);
        // console.log(logics[element][element1]);
        const { when, when_and_or_operator, then } = logics[element][element1];

        let conditionResult = when_and_or_operator === 'AND' ? true : false;

        for (const condition of when) {
          const result = evaluateCondition(condition, element);
          if (when_and_or_operator === 'AND') {
            conditionResult = conditionResult && result;
          } else {
            conditionResult = conditionResult || result;
          }
        }

        if (element == 'c0686b32-6e7b-4dde-a698-b9737c80a45a' || element == 'cfe5d132-b6b0-4a28-a505-c23ea9f4de2b') {
          // console.log("roiActionArr--2 ------------------------------------------")
          // console.log("roiActionArr--2", conditionResult)
        }
        //  console.log(logics[element][element1], conditionResult)
        if (conditionResult) {

          let calculated_arr = [];
          // then.forEach(action => executeAction(action));
          await then.forEach(action => {
            const { action: type, value, variable, variable_data_type, operator: action_type, value_type } = action;
            //console.log("executeAction", type, value, variable, variable_data_type, action_type, value_type)
            let val__;
            switch (type) {
              case 'calculate':
                if (action_type === 'assign') {
                  if (variable_data_type === 'number') {
                    if (value_type == "static") {
                      // console.log("assign static----n", value +"!= undefined &&"  + value +"!= null && "+value +"!= "+'""'+ " && "+value +"!= "+roiActionArr__[variable]?.['value'])
                      if (value != undefined && value != null && value != "" && value != roiActionArr__[variable]?.['value']) {
                        if (variable === '0bfa3ea6-a158-40fb-ac0e-195fdf4fd624') {
                          //console.log("roiActionArr__ changed static--end", variable, value)
                        }
                        if (roiActionArr__[variable]?.['value'] != 0 && roiActionArr__[variable]?.['value'] != '' && roiActionArr__[variable]?.['value'] != null && roiActionArr__[variable]?.['value'] != undefined && "1" == roiActionArr__[variable]?.['currency']) {

                        } else {
                          roiActionArr__ = {
                            ...roiActionArr__,
                            [variable]: {
                              ...roiActionArr__[variable],
                              value: value
                            }
                          };
                          calculated_arr.push({ variable: variable, value: parseFloat(value).toFixed(0) })
                        }
                      }
                    } else if (value_type == "dynamic") {
                      // console.log(roiActionArr__?.[value]?.value + "!=" + "undefined && " + roiActionArr__?.[value]?.value + "!= null && " + roiActionArr__?.[value]?.value + "!= " + `"" &&` + roiActionArr__?.[value]?.value + "!=" + roiActionArr__?.[variable]?.['value'] + "&& " + roiActionArr__?.[variable]?.['value'] + "!= undefined");
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && roiActionArr__?.[value]?.value != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        // console.log("assign dynamic----n", " I am here", roiActionArr__?.[value].value, roiActionArr__?.[variable]?.['value']);
                        let val = roiActionArr__[value].value;
                        //console.log("roiActionArr__ changed dynamic ", variable, val)
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: val
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }

                    }
                  }
                  else {
                    if (value_type == "static") {
                      // console.log("assign static----n", value +"!= undefined &&"  + value +"!= null && "+value +"!= "+'""'+ " && "+value +"!= "+roiActionArr__[variable]?.['value'])
                      if (value != undefined && value != null && value != "" && value != roiActionArr__[variable]?.['value']) {
                        //console.log("roiActionArr__ changed static--end - string", variable, value)
                        if (roiActionArr__[variable]?.['value'] != 0 && roiActionArr__[variable]?.['value'] != '' && roiActionArr__[variable]?.['value'] != null && roiActionArr__[variable]?.['value'] != undefined && "1" == roiActionArr__[variable]?.['currency']) {

                        } else {
                          roiActionArr__ = {
                            ...roiActionArr__,
                            [variable]: {
                              ...roiActionArr__[variable],
                              value: value
                            }
                          };
                          calculated_arr.push({ variable: variable, value: value })
                        }
                      }
                    } else if (value_type == "dynamic") {
                      // console.log(roiActionArr__?.[value]?.value + "!=" + "undefined && " + roiActionArr__?.[value]?.value + "!= null && " + roiActionArr__?.[value]?.value + "!= " + `"" &&` + roiActionArr__?.[value]?.value + "!=" + roiActionArr__?.[variable]?.['value'] + "&& " + roiActionArr__?.[variable]?.['value'] + "!= undefined");
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && roiActionArr__?.[value]?.value != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        // console.log("assign dynamic----n", " I am here", roiActionArr__?.[value].value, roiActionArr__?.[variable]?.['value']);
                        let val = roiActionArr__[value].value;
                        //console.log("roiActionArr__ changed dynamic - string", variable, val)
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: val
                          }
                        };
                        calculated_arr.push({ variable: variable, value: val })

                      }

                    }
                  }
                }

                if (action_type === 'add') {
                  if (variable_data_type === 'number') {
                    if (value_type == "static") {
                      let val = parseFloat(roiActionArr__[variable]?.value) + parseFloat(value);
                      if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                        //console.log("add static----n", " I am here", value, roiActionArr__[variable]?.['value']);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }
                    } else if (value_type == "dynamic") {
                      let val = parseFloat(roiActionArr__[variable]?.value) + parseFloat(roiActionArr__[value]?.value);
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        //console.log("add dynamic----n", " I am here", roiActionArr__?.[value]?.value, roiActionArr__?.[variable]?.['value']);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }

                    }
                  }
                }

                if (action_type === 'subtract') {
                  if (variable_data_type === 'number') {
                    if (value_type == "static") {
                      let val = parseFloat(roiActionArr__[variable]?.value) - parseFloat(value);
                      if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                        //console.log("subtract static----n", " I am here", value, roiActionArr__[variable]?.['value']);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }
                    } else if (value_type == "dynamic") {
                      let val = parseFloat(roiActionArr__[variable]?.value) - parseFloat(roiActionArr__[value]?.value);
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        //console.log("subtract dynamic----n", " I am here", roiActionArr__?.[value]?.value, roiActionArr__?.[variable]?.['value']);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }


                    }
                  }
                }

                if (action_type === 'multiply') {
                  if (variable_data_type === 'number') {
                    if (value_type == "static") {
                      let val = parseFloat(roiActionArr__[variable]?.value) * parseFloat(value);
                      if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                        //console.log("multiply static----n", " I am here", parseFloat(value), parseFloat(roiActionArr__[variable]?.['value']), val);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }
                    } else if (value_type == "dynamic") {
                      let val = parseFloat(roiActionArr__[variable]?.value) * parseFloat(roiActionArr__[value]?.value);
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        //console.log("multiply dynamic----n", " I am here", parseFloat(roiActionArr__?.[value]?.value), parseFloat(roiActionArr__?.[variable]?.['value']), val);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }

                    }
                  }
                }

                if (action_type === 'divide') {
                  if (variable_data_type === 'number') {
                    if (value_type == "static") {
                      let val = parseFloat(roiActionArr__[variable]?.value) / parseFloat(value);
                      if (value != undefined && value != null && value != "" && val != roiActionArr__[variable]?.['value'] && roiActionArr__[variable]?.['value'] != undefined) {
                        //console.log("divide static----n", " I am here", parseFloat(value), parseFloat(roiActionArr__[variable]?.['value']), val);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }
                    } else if (value_type == "dynamic") {
                      let val = parseFloat(roiActionArr__[variable]?.value) / parseFloat(roiActionArr__[value]?.value);
                      if (roiActionArr__?.[value]?.value != undefined && roiActionArr__?.[value]?.value != null && roiActionArr__?.[value]?.value != "" && val != roiActionArr__?.[variable]?.['value'] && roiActionArr__?.[variable]?.['value'] != undefined) {
                        //console.log("divide dynamic----n", " I am here", parseFloat(roiActionArr__?.[value]?.value), parseFloat(roiActionArr__?.[variable]?.['value']), val);
                        roiActionArr__ = {
                          ...roiActionArr__,
                          [variable]: {
                            ...roiActionArr__[variable],
                            value: parseFloat(val)
                          }
                        };
                        calculated_arr.push({ variable: variable, value: parseFloat(val).toFixed(0) })
                      }

                    }
                  }
                }
                break;
              case 'show_blocks':
              case 'hide_blocks':
                //console.log(`${type} these blocks: ${value}`);
                break;
              case 'disable_item':
                //console.log(`Disabling item: ${value}`);
                break;

              default:
              //console.log('Action not recognized');
            }

            // if (val__ != undefined) {
            // console.log("updateValueForRenderAllPages", variable, val__)
            // updateValueForRenderAllPages(variable, val__);
            // }
          });

          // console.log("roiActionArr calculated_arr top", element, calculated_arr)
          //assigning all calculated values to roiActionArr
          calculated_arr?.forEach((element, index) => {
            // console.log("updateValueForRenderAllPages", element.variable, element.value)
            if (element.value != undefined && element.value != null && element.value != "" && roiActionArr[element.variable]?.['value'] != roiActionArr__[element.variable]?.['value']) {
              roiActionArr__ = {
                ...roiActionArr__,
                [element.variable]: {
                  ...roiActionArr__[element.variable],
                  // value: element.value,
                  count: roiActionArr__[element.variable]?.count + 1
                }
              };

              if (count < roiActionArr__[element.variable]?.count) {
                //console.log("is_count", element.variable)
                //console.log("is_count", roiActionArr__[element.variable])
                count = roiActionArr__[element.variable]?.count;
              }
              is_changed = 1;
              // console.log("is_changed", is_changed)
              // setRoiFlag(true);
              calculated_arr_global.push(element);
            }

            if (calculated_arr.length - 1 == index && is_changed == 2) {
              is_changed = 3;
            }
          });

          // if (calculated_arr.length > 0) {
          //     calculated_arr_global.push(calculated_arr);
          // }
        }
      });
    });


    //console.log("is_changed print roi action array  ", roiActionArr__)
    // console.log("is_changed", is_changed)
    // console.log("is_count", count)
    // console.log("globalRoiArr", updateValues(globalRoiArr))
    // console.log("roiActionArr print", calculated_arr_global)
    if (is_changed == 1 && count < 30) { //count to stop executing the logic after 4 times or 4 level depth
      //console.log("is_changed", is_changed)
      setGlobalRoiArr(globalRoiArr.concat(calculated_arr_global))
      setRoiActionArr(roiActionArr__);
    } else if (is_changed == 3 && globalRoiArr.length > 0) {
      await updateValueForRenderAllPages(updateValues(globalRoiArr));
      setGlobalRoiArr([]);
    }
  };

  const updateValues = (arr) => {
    const resultMap = {};

    arr.forEach(item => {
      resultMap[item.variable] = item.value;
    });

    return Object.keys(resultMap).map(key => ({
      variable: key,
      value: resultMap[key]
    }));
  };

  function debounce(func, delay) {
    let timer;
    return function (...args) {
      const context = this; // Capture context if needed (useful for non-arrow functions)
      clearTimeout(timer);
      timer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  const updateErrorRequiredByUuid = useCallback(async (pageUuid, elementUuid, newValue) => {
    //console.log("updateValueByUuid", pageUuid, elementUuid, newValue)
    // Function to traverse and update the page data
    let level = 0;
    const traverseAndUpdate = async (data) => {
      // console.log("data", data)
      if (Array.isArray(data)) {
        const results = await Promise.all(data.map(item => traverseAndUpdate(item)));
        return results;
      } else if (data !== null && typeof data === 'object') {
        const newObj = {};
        for (const key of Object.keys(data)) {

          const value = data[key];
          if (key === 'uuid' && value === elementUuid && data.hasOwnProperty('value')) {
            newObj[key] = value; // keep uuid the same
            newObj['errorMessage'] = newValue; // update the value
            newObj['value'] = ''; // update the value
          } else if ((key !== 'errorMessage' && key !== 'value' && data['uuid'] == elementUuid)
            || (data['uuid'] != elementUuid)) {
            level++;
            if (typeof value === 'object') {
              newObj[key] = await traverseAndUpdate(value);
            } else {
              newObj[key] = value;
            }
          } else if (key === 'errorMessage' && newObj['errorMessage'] === undefined) {
            newObj['errorMessage'] = data[key];
          }


        }
        // console.log("newObj", newObj)
        return newObj;
      } else {
        return data;
      }
    };


    // Only update the specific page
    if (roipages.hasOwnProperty(pageUuid)) {
      // console.log("pageUuid", pageUuid)
      // console.log("roipages--121", roipages)
      // console.log("roipages--12", roipages[pageUuid])
      let pagedata = JSON.parse(JSON.stringify(roipages));
      // console.log("pagedata", pagedata)
      const updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]));
      //console.log("updatedPage", updatedPage, pageUuid)
      setRoipages(prevData => {
        return {
          ...prevData,
          [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
        }
      });
      // console.log("roipages--1", roipages)
    }
  }, [roipages]);

  const updateValueByUuid = useCallback(async (pageUuid, elementUuid, newValue) => {
    //console.log("updateValueByUuid", pageUuid, elementUuid, newValue)
    // Function to traverse and update the page data
    let level = 0;
    const traverseAndUpdate = async (data) => {
      // console.log("data", data)
      if (Array.isArray(data)) {
        const results = await Promise.all(data.map(item => traverseAndUpdate(item)));
        return results;
      } else if (data !== null && typeof data === 'object') {
        const newObj = {};
        for (const key of Object.keys(data)) {


          if (data.hasOwnProperty('Cell1Data')) { // Check if the object has the key 'Cell1Data' for table data
            const value = data[key];
            let check_digit = 0;
            if (value == elementUuid) {
              const regex = /(\d+)/;
              const digit = key.match(regex);
              newObj['Cell' + digit[0] + 'Data'] = newValue;
              newObj['Cell' + digit[0] + 'uuid'] = value;
              check_digit = digit[0];
            } else if (value != elementUuid) {
              if (check_digit != 0 && key == 'Cell' + check_digit + 'Data') {

              } else {
                newObj[key] = value;
              }
            }
          } else {
            const value = data[key];
            if (key === 'uuid' && value === elementUuid && data.hasOwnProperty('value')) {
              newObj[key] = value; // keep uuid the same
              newObj['value'] = newValue; // update the value
              newObj['errorMessage'] = '';
            } else if ((key !== 'errorMessage' && key !== 'value' && data['uuid'] == elementUuid)
              || (data['uuid'] != elementUuid)) {
              level++;
              if (typeof value === 'object') {
                newObj[key] = await traverseAndUpdate(value);
              } else {
                newObj[key] = value;
              }
            } else if (key === 'value' && newObj['value'] === undefined) {
              newObj['value'] = data[key];
            }
          }
        }
        // console.log("newObj", newObj)
        return newObj;
      } else {
        return data;
      }
    };


    // Only update the specific page
    if (roipages.hasOwnProperty(pageUuid)) {
      // console.log("pageUuid", pageUuid)
      // console.log("roipages--121", roipages)
      // console.log("roipages--12", roipages[pageUuid])
      let pagedata = JSON.parse(JSON.stringify(roipages));
      // console.log("pagedata", pagedata)
      const updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]));
      //console.log("updatedPage", updatedPage, pageUuid)
      setRoipages(prevData => {
        return {
          ...prevData,
          [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
        }
      });
      // console.log("roipages--1", roipages)
    }
  }, [roipages]);


  const updateValueForRenderAllPages = useCallback(async (calculated_arr_global) => {
    //.log("I am in updateValueForRenderAllPages", calculated_arr_global)
    // let elementUuid = '', newValue = '';
    // Function to traverse and update the page data
    let level = 0;
    const traverseAndUpdate = async (data, calculated_arr_global, pageUuid) => {
      // console.log("data", data)
      if (Array.isArray(data)) {
        const results = await Promise.all(data.map(item => traverseAndUpdate(item, calculated_arr_global, pageUuid)));
        return results;
      } else if (data !== null && typeof data === 'object') {
        const newObj = {};
        for (const key of Object.keys(data)) {

          if (data.hasOwnProperty('Cell1Data')) { // Check if the object has the key 'Cell1Data' for table data
            const value = data[key];
            let check__ = false;
            let check_digit = 0;
            await Object.keys(calculated_arr_global).forEach(async (element) => {

              if (value == calculated_arr_global[element].variable) {

                const regex = /(\d+)/;
                const digit = key.match(regex);
                newObj['Cell' + digit[0] + 'Data'] = calculated_arr_global[element].value;
                newObj['Cell' + digit[0] + 'uuid'] = value;
                check_digit = digit[0];
                check__ = true;
              }
            });

            if (check__ == false) {
              // if (value != element.variable) {
              if (check_digit != 0 && key == 'Cell' + check_digit + 'Data') {

              } else {
                newObj[key] = value;
              }
              // }
            }
          } else if (data.hasOwnProperty('Value1')) { // Check if the object has the key 'Cell1Data' for table data
            const value = data[key];
            let check__ = false;
            let check_digit = 0;
            await Object.keys(calculated_arr_global).forEach(async (element) => {

              if (value == calculated_arr_global[element].variable) {

                const regex = /(\d+)/;
                const digit = key.match(regex);
                newObj['Value' + digit[0]] = calculated_arr_global[element].value;
                newObj['Value' + digit[0] + 'uuid'] = value;
                check_digit = digit[0];
                check__ = true;
              }
            });

            if (check__ == false) {
              // if (value != element.variable) {
              if (check_digit != 0 && key == 'Value' + check_digit) {

              } else {
                newObj[key] = value;
              }
              // }
            }
          } else {
            const value = data[key];
            let check__ = false;
            await Object.keys(calculated_arr_global).forEach(async (element) => {
              if (key === 'uuid' && value === calculated_arr_global[element].variable && data.hasOwnProperty('value')) {
                //console.log("new value", calculated_arr_global[element].value);
                newObj[key] = value; // keep uuid the same
                newObj['value'] = calculated_arr_global[element].value; // update the value
                check__ = true;
              }
            });
            if (check__ == false) {
              if (key !== 'value') {
                level++;
                if (typeof value === 'object') {
                  newObj[key] = await traverseAndUpdate(value, calculated_arr_global, [pageUuid]);
                } else {
                  newObj[key] = value;
                }
              } else if (key === 'value' && newObj['value'] === undefined) {
                newObj['value'] = data[key];
              }
            }
          }
        }
        // console.log("newObj", newObj)
        return newObj;
      } else {
        return data;
      }
    };


    // Only update the specific page
    let roipages__ = JSON.parse(JSON.stringify(roipages));
    await Object.keys(roipages__).forEach(async (pageUuid, index) => {
      let pagedata = JSON.parse(JSON.stringify(roipages__));
      //loop to update all updated element at once in a page
      // let updatedPage = JSON.parse(pagedata[pageUuid]);
      // Object.keys(calculated_arr_global).forEach(async (element) => {
      if (pageUuid == 'aefec6f0-05ef-11ef-8e01-1982dfb1577d') {
        //console.log("updating all roi pages aefec6f0-05ef-11ef-8e01-1982dfb1577d--start", pagedata[pageUuid])
      }
      let updatedPage = await traverseAndUpdate(JSON.parse(pagedata[pageUuid]), calculated_arr_global, pageUuid);
      //console.log("updating all roi pages ", JSON.stringify(updatedPage))
      if (pageUuid == 'aefec6f0-05ef-11ef-8e01-1982dfb1577d') {
        //console.log("updating all roi pages aefec6f0-05ef-11ef-8e01-1982dfb1577d", JSON.stringify(updatedPage))
      }

      // });

      // setRoipages(prevData => {
      //     return {
      //         ...prevData,
      //         [pageUuid]: JSON.stringify(updatedPage) // Update only the specific page
      //     }
      // });

      roipages__[pageUuid] = JSON.stringify(updatedPage);
      if (index == Object.keys(roipages__).length - 1) {
        //console.log("I am in updateValueForRenderAllPages--end");
        setRoipages(roipages__);
      }

    });
  }, [roipages]);

  //for inputs type text
  const handleChange = useCallback(async (uuid, e, required = false) => {
    if (e.target.value == '' && required == true) {
      // toast.error('Please enter a valid value');
      let errorMessage = 'Please enter a valid value';
      await updateErrorRequiredByUuid(currentPageId, uuid, errorMessage);

      const updatedRoiActionArr = {
        ...roiActionArr,
        [uuid]: {
          ...roiActionArr[uuid],
          value: ''
        }
      };
      //console.log("roiActionArr--2", updatedRoiActionArr)
      setRoiActionArr(updatedRoiActionArr);
    } else {
      if (uuid !== '' && uuid !== undefined && uuid !== null && e !== '' && e !== undefined && e !== null) {


        // console.log('roipages[1123]', roipages[currentPageId])
        // console.log(roiActionArr);
        //console.log(uuid);
        // console.log(e.target.value);
        const updatedRoiActionArr = {
          ...roiActionArr,
          [uuid]: {
            ...roiActionArr[uuid],
            value: e.target.value
          }
        };
        //console.log("roiActionArr--2", updatedRoiActionArr)
        setRoiActionArr(updatedRoiActionArr);
        if (popupStatus == false) {
          await updateValueByUuid(currentPageId, uuid, e.target.value);
        }
        if (popupStatus == true) {
          await updateValueByUuid(currentPopupPageId, uuid, e.target.value);
        }
        // Update the state with the new object

      }
    }
  }, [roiActionArr, currentPageId, updateValueByUuid]);

  //for checkbox
  const onCheckBoxClick = useCallback(async (uuid) => {
    let value = roiActionArr[uuid].value;
    if (value == '1') {
      const updatedRoiActionArr = {
        ...roiActionArr,
        [uuid]: {
          ...roiActionArr[uuid],
          value: '0'
        }
      };
      value = '0';
      setRoiActionArr(updatedRoiActionArr);
      await updateValueByUuid(currentPageId, uuid, value);


    } else {
      const updatedRoiActionArr = {
        ...roiActionArr,
        [uuid]: {
          ...roiActionArr[uuid],
          value: '1'
        }
      };
      value = '1';
      setRoiActionArr(updatedRoiActionArr);
      await updateValueByUuid(currentPageId, uuid, value);


    }


  }, [roiActionArr, currentPageId, updateValueByUuid]);

  const handleDropdownChange = useCallback(async (uuid, e) => {
    //console.log("uuid", uuid, e.target.value)
    const changedArr = {
      ...changedDropdown,
      [uuid]: e.target.value

    };
    //console.log("changedArr", changedArr)
    setChangedDropdown(changedArr);

    const updatedRoiActionArr = {
      ...roiActionArr,
      [uuid]: {
        ...roiActionArr[uuid],
        value: e.target.value
      }
    };
    //console.log("roiActionArr--2", updatedRoiActionArr)
    setRoiActionArr(updatedRoiActionArr);
    await updateValueByUuid(currentPageId, uuid, e.target.value);
  }, [roiActionArr, currentPageId, updateValueByUuid]);




  // Debounce function with useCallback
  const debouncedOnChange = useMemo(() => debounce(handleChange, 1000), [handleChange]);

  const config = {
    categories: {
      Banner: {
        components: ["BannerLeftTextRightImage", "BannerCenterText"],
      },

      Cards: {
        components: ["CardLayout1", "CardLayout2"],
      },
    },

    components: {
      //Header Components
      PageHeader: {
        render: ({
          logo,
          items,
          hide,
          showCurrencyDropdown,
          showRecalculateButton,
          showLanguageDropdown,
          transparentHeader,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;



          return (
            <div
              className={`roi-header-main ${transparentHeader && "header-transparent"
                }`}
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  {/* <a href="" className="logo">
                                        <img src={logo} alt="" onClick={homeRedirect} />
                                    </a> */}
                  <a
                    href="#"
                    className="logo"
                    data-bs-toggle="modal"
                    data-bs-target="#logoPrompt"
                  >
                    {logo ? (
                      <img src={logo} alt="" />
                    ) : (
                      <img src={logo_fallback} alt="" />
                    )}
                  </a>
                  <div className="nav-menu">
                    <ul>

                    </ul>
                  </div>
                  <div className="space">

                  </div>
                </div>
              </div>
            </div>
          );
        },
      },

      PageHeader2: {

        render: ({ logo1, logo2, logo3, absolutePosition, whiteHeader }) => {
          // Calculate opacity based on hide value
          return (
            <div className={`tco-header-main ${absolutePosition && 'absolute-position'} ${whiteHeader && 'header-white'}`}>
              <div className="tco-container">
                <div className="header-wrapper-top">
                  <Link to="" className="logo">
                    <img src={logo1} alt="" />
                  </Link>
                  <Link to="" className="logo">
                    <img src={logo2} alt="" />
                  </Link>
                </div>
                {logo3 &&
                  <div className="header-wrapper-bottom">
                    <Link to="" className="logo">
                      <img src={logo3} alt="" />
                    </Link>
                  </div>
                }
              </div>
            </div>
          )
        },
      },

      PageHeaderTransparent: {
        render: ({ logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <div
              className="roi-header-transparent"
              style={{ opacity: inputOpacity }}
            >
              <div className="container">
                <div className="header-wrapper">
                  <a className="logo">
                    <img src={logo} alt="" />
                  </a>
                </div>
              </div>
            </div>
          );
        },
      },

      // Banner Layouts
      BannerLeftTextRightImage: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          Style,
          image,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative ${Padding.bottom
                  } ${Padding.top} ${Style} ${Padding.fullHeight && "full-height"
                  }`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="row align-items-center ">
                    <div className="col-lg-6">
                      <div className="banner-text">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              onClick={() => onButtonClick(Button.uuid)}
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              onClick={() => onButtonClick(Button.uuid)}
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>

                    <div className="col-lg-6">
                      <div className="img-wrapper">
                        <img src={image} className="img-fluid" alt="" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      BannerCenterText: {
        render: ({
          Heading,
          Description,
          Button,
          Padding,
          image,
          Style,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-banner-section position-relative banner-center-text ${Style} ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${image}")`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  backgroundRepeat: "no-repeat",
                  opacity: inputOpacity,
                }}
              >
                <div className="overlay"></div>
                <div className="container position-relative">
                  <div className="row align-items-center justify-content-center">
                    <div className="col-lg-8">
                      <div className="banner-text text-center">
                        <h1
                          className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                        >
                          {Heading.title}
                        </h1>

                        <div className="text-part">
                          <div
                            className={Description.descriptionFont}
                            dangerouslySetInnerHTML={{
                              __html: Description.text,
                            }}
                          ></div>
                        </div>

                        <div className="button-wrap">
                          {Button.buttonicon === "yes" ? (
                            <button
                              className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              <span className="with-icon">
                                {Button.buttonText}
                              </span>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </button>
                          ) : (
                            <button
                              className={`btn roi-btn-${Button.buttonStyle}`}
                              type="submit"
                            >
                              {Button.buttonText}
                            </button>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Cards Layouts
      CardLayout1: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          Card4,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-1 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="card-nav-outer">
                  <div className="container">
                    <div className="card-nav d-flex align-items-center justify-content-between">
                      {/* <div className="card-prev text-start">
                                                <button className='prev-btn card-btn'>Back</button>
                                            </div> */}

                      <div className="card-next text-end">
                        {/**Only Hide button in case not to be shown**/}
                        {/* <button className='next-btn card-btn'>Next</button> */}
                      </div>
                    </div>
                  </div>
                </div>

                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>

                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card1.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div
                          className="card-outer"
                          onClick={() => onButtonClick(Card2.uuid)}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      {Card3 != undefined && Card3 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card3.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card3.title}</h4>
                                <p>{Card3.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                      {Card4 != undefined && Card4 != null && (
                        <div className="col-lg-4 col-md-6 mb-3">
                          <div
                            className="card-outer"
                            onClick={() => onButtonClick(Card4.uuid)}
                          >
                            <div className="card-inner">
                              <div className="text-wrapper">
                                <h4>{Card4.title}</h4>
                                <p>{Card4.text}</p>
                              </div>
                              <div className="button-wrapper">
                                <button className="btn btn-action">
                                  <Svg name="roi-card-button" />
                                </button>
                              </div>
                            </div>
                          </div>
                        </div>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardLayout2: {
        render: ({
          Heading,
          Description,
          Padding,
          Card1,
          Card2,
          Card3,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-cards-section card-layout-2 position-relative ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="section-heading mb-3 mb-md-5 text-center">
                    <h2
                      className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                    >
                      {Heading.title}
                    </h2>
                    <p className={Description.descriptionFont}>
                      {Description.text}
                    </p>
                  </div>
                  <div className="cards-wrapper">
                    <div className="row justify-content-center">
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card1.title}</h4>
                              <p>{Card1.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card2.title}</h4>
                              <p>{Card2.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="col-lg-4 col-md-6 mb-3">
                        <div className="card-outer">
                          <div className="card-inner">
                            <div className="icon-wrapper">
                              <Svg name="roi-card-icon" />
                            </div>
                            <div className="text-wrapper">
                              <h4>{Card3.title}</h4>
                              <p>{Card3.text}</p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Layouts
      SinglePage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone="nav-wrapper" allow={["FormNav"]} />
                  <div className="form-wrapper">
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.descriptionFont}>
                        {Description.text}
                      </p>
                    </div>
                    <div className="form-inner">
                      <DropZone
                        zone="form-wrapper"
                        disallow={["SinglePage", "WizardForm"]}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      FormNav: {
        render: ({ items, hide }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <ul className="nav nav-tabs nav-tabs-single">
                {items.map((item, i) => (
                  <li className="nav-item" role="presentation" key={i}>
                    {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                    <button
                      onClick={() => onButtonClick(item.uuid)}
                      className={
                        item.isActive == true ? "nav-link active" : "nav-link"
                      }
                    >
                      {item.Title}
                    </button>
                  </li>
                ))}
              </ul>
            </>
          );
        },
      },

      WizardForm: {
        render: ({ Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-forms-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <ul className="nav nav-tabs" id="myTab" role="tablist">
                    {items.map((item, i) => (
                      <li className="nav-item" role="presentation" key={i}>
                        {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                        <button
                          className={i === 0 ? "nav-link active" : "nav-link"}
                          id={`tab-${i}`}
                          data-bs-toggle="tab"
                          data-bs-target={`#tab-${i}-pane`}
                          type="button"
                          role="tab"
                          aria-controls={`tab-${i}-pane`}
                          aria-selected="false"
                        >
                          {item.Title}
                        </button>
                      </li>
                    ))}
                  </ul>
                  <div className="form-wrapper">
                    <div className="tab-content" id="myTabContent">
                      {items.map((item, i) => (
                        <div
                          key={i}
                          className={
                            i === 0
                              ? "tab-pane fade show active"
                              : "tab-pane fade"
                          }
                          id={`tab-${i}-pane`}
                          role="tabpanel"
                          aria-labelledby={`tab-${i}`}
                          tabIndex={0}
                        >
                          <div className="section-heading mb-3 mb-md-4">
                            <h2 className={`heading fw-700 fs-40`}>
                              {item.Title}
                            </h2>
                            <p className="fs-22">{item.Description}</p>
                          </div>
                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper-${i}`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                        </div>
                      ))}
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      //Form Elements

      InputTextField: {
        render: ({
          label,
          showLabel,
          disableEditing,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hide,
          Prefix,
          uuid,
          tabIndex,
          Style,
          Font,
          Border,
          Padding,
          Margin,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label" for={uuid}>
                    {label} {required && <span className="required">*</span>}{" "}
                    {hint && (
                      <div className="hint">
                        <button className="info">
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {(() => {
                    if (Prefix === "currency") {
                      return (
                        <input

                          {...(disableEditing ? { disabled: true } : {})}
                          type="text"
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                          defaultValue={CurrencyFormatter({
                            amount: parseFloat(value),
                          }).normalize()}
                          id={uuid}
                          tabIndex={tabIndex ?? ""}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onBlur={(e) => handleChange(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                          }}
                        />
                      );
                    } else {
                      return (
                        <input
                          {...(disableEditing ? { disabled: true } : {})}
                          type="text"
                          className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                            } ${errorMessage ? "error" : ""}`}
                          placeholder={placeholder}
                          // value={roiActionArr[uuid] ? ((roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : value) : value}
                          defaultValue={value}
                          id={uuid}
                          tabIndex={tabIndex ?? ""}
                          // value={ (roiActionArr[uuid]?.value!='') ? roiActionArr[uuid]?.value : roiActionArr[uuid]?.default_value}
                          required={required}
                          onBlur={(e) => handleChange(uuid, e, required)}
                          style={{
                            backgroundColor: `${Style?.BackgroundColor}`,
                            color: `${Style?.Color}`,

                            padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                            borderStyle: `${Border?.BorderStyle}`,
                            borderColor: `${Border?.BorderColor}`,
                            borderWidth: `${Border?.BorderWidth}px`,
                            borderRadius: `${Border?.BorderRadius}px`,
                            height: `${Style?.Height}px`,
                            textAlign: Font?.Align,
                            display: `${Style?.Display}`,
                          }}
                        />
                      );
                    }
                  })()}

                  {!showLabel && hint && (
                    <div className="hint">
                      <button className="info">
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      InputNumberField: {
        render: ({
          label,
          showLabel,
          value,
          placeholder,
          required,
          errorMessage,
          hint,
          hide,
          Prefix,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
          tabIndex,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}{" "}
                    {hint && (
                      <div className="hint">
                        <button className="info">
                          <Svg name="hint-button" />
                        </button>
                        <div
                          className="popover"
                          dangerouslySetInnerHTML={{ __html: hint }}
                        ></div>
                      </div>
                    )}
                  </label>
                )}
                <div className="position-relative">
                  {Prefix == "none" && (
                    <input
                      type="number"
                      className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                        } ${errorMessage ? "error" : ""}`}
                      placeholder={placeholder}
                      defaultValue={value}
                      id={uuid}
                      tabIndex={tabIndex ?? ""}
                      required={required}
                      onBlur={(e) => handleChange(uuid, e, required)}
                      style={{
                        backgroundColor: `${Style?.BackgroundColor}`,
                        color: `${Style?.Color}`,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                        borderStyle: `${Border?.BorderStyle}`,
                        borderColor: `${Border?.BorderColor}`,
                        borderWidth: `${Border?.BorderWidth}px`,
                        borderRadius: `${Border?.BorderRadius}px`,
                        height: `${Style?.Height}px`,
                        textAlign: Font?.Align,
                      }}
                    />
                  )}

                  {Prefix == "%" && (
                    <div className="input-group percent">
                      <input
                        type="number"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        tabIndex={tabIndex ?? ""}
                        required={required}
                        onBlur={(e) => handleChange(uuid, e)}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                        }}
                      />
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                      >
                        %
                      </span>
                    </div>
                  )}

                  {Prefix == "currency" && (
                    <div className="input-group currency">
                      <span
                        className={`input-group-text ${Font?.fontWeight} ${Font?.fontSize}`}
                        style={{
                          color: `${Style?.Color}`,
                        }}
                        dangerouslySetInnerHTML={{ __html: currencySymbol }}
                      ></span>
                      {/**Change this currency depending upon default currency**/}
                      <input
                        type="number"
                        className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                          } ${errorMessage ? "error" : ""}`}
                        placeholder={placeholder}
                        defaultValue={value}
                        tabIndex={tabIndex ?? ""}
                        required={required}
                        onBlur={(e) => handleChange(uuid, e)}
                        style={{
                          backgroundColor: `${Style?.BackgroundColor}`,
                          color: `${Style?.Color}`,
                          padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                          borderStyle: `${Border?.BorderStyle}`,
                          borderColor: `${Border?.BorderColor}`,
                          borderWidth: `${Border?.BorderWidth}px`,
                          borderRadius: `${Border?.BorderRadius}px`,
                          height: `${Style?.Height}px`,
                          textAlign: Font?.Align,
                        }}
                      />
                    </div>
                  )}

                  {!showLabel && hint && (
                    <div className="hint">
                      <button className="info">
                        <Svg name="hint-button" />
                      </button>
                      <div
                        className="popover"
                        dangerouslySetInnerHTML={{ __html: hint }}
                      ></div>
                    </div>
                  )}
                </div>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      TextareaField: {
        render: ({
          label,
          value,
          placeholder,
          required,
          errorMessage,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          showLabel,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <textarea
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  value={value}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Dropdown: {
        render: ({
          label,
          showLabel,
          required,
          errorMessage,
          items,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
          uuid,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <select
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize
                    } ${errorMessage ? "error" : ""}`}
                  onChange={(e) => handleDropdownChange(uuid, e)}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    backgroundSize: `${Style?.DropdownSize}px`,
                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                  }}
                  defaultValue={changedDropdown[uuid]}
                >
                  <option value>--Select--</option>
                  {items.map((item, i) => (
                    <option key={i} value={item.Option}>
                      {item.Option}
                    </option>
                  ))}
                </select>

                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },



      PhoneNumber: {
        render: ({
          label,
          showLabel,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
          Style,
          Font,
          Border,
          Padding,
          Margin,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                {showLabel && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${Font?.fontWeight} ${Font?.fontSize ? `${Font?.fontSize}` : "fs-18"
                    } ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  required={required}
                  style={{
                    backgroundColor: `${Style?.BackgroundColor}`,
                    color: `${Style?.Color}`,

                    padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                    borderStyle: `${Border?.BorderStyle}`,
                    borderColor: `${Border?.BorderColor}`,
                    borderWidth: `${Border?.BorderWidth}px`,
                    borderRadius: `${Border?.BorderRadius}px`,
                    height: `${Style?.Height}px`,
                    textAlign: Font?.Align,
                  }}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Email: {
        render: ({
          label,
          placeholder,
          required,
          errorMessage,
          value,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  value={value}
                  required={required}
                />
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Date: {
        render: ({
          label,
          required,
          errorMessage,
          hide,
          onChange,
          placeholder,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <input
                  type="text"
                  className={`form-control ${errorMessage ? "error" : ""}`}
                  placeholder={placeholder}
                  required={required}
                  onChange={onChange}
                />

                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                {/* <DateField /> */}
                {errorMessage && (
                  <div className="input-error">{errorMessage}</div>
                )}
              </div>
            </>
          );
        },
      },

      Range: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                {/* <input type="text" className={`form-control ${errorMessage ? 'error' : ''}`} placeholder={placeholder} value={value} required={required} /> */}
                <Range />
              </div>
            </>
          );
        },
      },

      Toggle: {
        render: ({ label, required, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="roi-form-group mb-3 position-relative"
                style={{ opacity: inputOpacity }}
              >
                {label && (
                  <label className="field-label">
                    {label} {required && <span className="required">*</span>}
                  </label>
                )}
                <div className="check-switch">
                  <label>No</label>
                  <input id="agree-check" type="checkbox" defaultChecked />
                  <label>Yes</label>
                </div>
              </div>
            </>
          );
        },
      },

      Button: {
        render: ({
          buttonText,
          buttonAction,
          conditionalLogic,
          buttonLink,
          buttonStyle,
          buttonicon,
          hide,
          uuid,
          customStyle,
          Style,
          spacing,
          iconPosition,
          popupTargetId,
          buttonAlignment,
        }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          // Prepare conditional attributes for the Bootstrap modal
          const modalTriggerAttributes = {};
          if (buttonAction === "OpenPopup" && popupTargetId) {
            modalTriggerAttributes["data-bs-toggle"] = "modal";
            // Ensure popupTargetId from Puck field doesn't include '#'
            // Prepend '#' when setting data-bs-target
            modalTriggerAttributes[
              "data-bs-target"
            ] = `#${popupTargetId.replace(/^#/, "")}`;
          }

          return (
            <>
              <div
                className={`button-wrap text-${buttonAlignment}`}
                style={{ opacity: inputOpacity }}
              >
                {(() => {
                  if (buttonAction === "OpenPopup") {
                    return buttonicon === "yes" ? (
                      <button
                        // {...modalTriggerAttributes}
                        onClick={() => {
                          changeModal();
                        }}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        {...modalTriggerAttributes}
                        //data-bs-toggle="modal"
                        //data-bs-target="#reportModal"
                        //onClick={() => onButtonClick(uuid)}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } else if (buttonAction === "ClosePopup") {
                    return buttonicon === "yes" ? (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          ) : (
                            <>
                              <Svg name="arrow-right-icn-roi" />
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <Svg name="arrow-right-icn-roi" />
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <Svg name="arrow-right-icn-roi" />
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        data-bs-dismiss="modal"
                        onClick={() => onButtonClick(uuid, "ClosePopup 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  } 
                  else if(buttonAction === "JumpToUrl"){
                      return buttonicon === "yes" ? (
                        <a
                        href={buttonLink}
                          // onClick={() => onButtonClick(uuid, "nothing")}
                          className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                            ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                            : ""
                            }`}
                         target="_blank"
                          style={
                            customStyle
                              ? {
                                backgroundColor: Style?.BackgroundColor,
                                color: Style?.Font?.Color,
                                padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                borderStyle: Style?.Border?.BorderStyle,
                                borderColor: Style?.Border?.BorderColor,
                                borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                borderRadius: `${Style?.Border.BorderRadius}px`,
                                gap: `${spacing ? `${spacing}px` : "20px"}`,
                              }
                              : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                          }
                        >
                          {iconPosition === "left" ? (
                            customStyle ? (
                              <>
                                <Svg name="roi-button-icon-2" /> {buttonText}
                              </>
                            ) : (
                              <>
                                <div className="icon">
                                  <Svg name="roi-button-icon" />
                                </div>
                                {buttonText}
                              </>
                            )
                          ) : iconPosition === "right" ? (
                            customStyle ? (
                              <>
                                {buttonText} <Svg name="roi-button-icon-2" />
                              </>
                            ) : (
                              <>
                                {buttonText}
                                <div className="icon">
                                  <Svg name="roi-button-icon" />
                                </div>
                              </>
                            )
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )}
                        </a>
                      ) : (
                        <a
                         
                          className={`btn roi-btn-${buttonStyle} ${customStyle
                            ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                            : ""
                            }`}
                          target="_blank"
                          style={
                            customStyle
                              ? {
                                backgroundColor: Style?.BackgroundColor,
                                color: Style?.Font?.Color,
                                padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                                margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                                borderStyle: Style?.Border?.BorderStyle,
                                borderColor: Style?.Border?.BorderColor,
                                borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                                borderRadius: `${Style?.Border.BorderRadius}px`,
                              }
                              : {}
                          }

                          href={buttonLink}
                        >
                          {buttonText}
                        </a>
                      );
                    
                  }else {
                    return buttonicon === "yes" ? (
                      <button
                        onMouseDown={(e) => {
                          // Handle button logic here before blur/render happens
                          // e.preventDefault(); // optional: prevent focus loss
                          onButtonClick(uuid, "nothing");
                        }}
                        // onClick={() => onButtonClick(uuid, "nothing")}
                        className={`d-inline-flex align-items-center btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                              gap: `${spacing ? `${spacing}px` : "20px"}`,
                            }
                            : { gap: `${spacing ? `${spacing}px` : "20px"}` }
                        }
                      >
                        {iconPosition === "left" ? (
                          customStyle ? (
                            <>
                              <Svg name="roi-button-icon-2" /> {buttonText}
                            </>
                          ) : (
                            <>
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                              {buttonText}
                            </>
                          )
                        ) : iconPosition === "right" ? (
                          customStyle ? (
                            <>
                              {buttonText} <Svg name="roi-button-icon-2" />
                            </>
                          ) : (
                            <>
                              {buttonText}
                              <div className="icon">
                                <Svg name="roi-button-icon" />
                              </div>
                            </>
                          )
                        ) : (
                          <>
                            {buttonText}
                            <div className="icon">
                              <Svg name="roi-button-icon" />
                            </div>
                          </>
                        )}
                      </button>
                    ) : (
                      <button
                        onClick={() => onButtonClick(uuid, "nothing 2")}
                        className={`btn roi-btn-${buttonStyle} ${customStyle
                          ? `custom-style ${Style?.Font?.fontWeight} ${Style?.Font?.fontSize}`
                          : ""
                          }`}
                        type="submit"
                        style={
                          customStyle
                            ? {
                              backgroundColor: Style?.BackgroundColor,
                              color: Style?.Font?.Color,
                              padding: `${Style?.Padding?.top}px ${Style?.Padding?.right}px ${Style?.Padding?.bottom}px ${Style?.Padding?.left}px`,
                              margin: `${Style?.Margin?.top}px ${Style?.Margin?.right}px ${Style?.Margin?.bottom}px ${Style?.Margin?.left}px`,
                              borderStyle: Style?.Border?.BorderStyle,
                              borderColor: Style?.Border?.BorderColor,
                              borderWidth: `${Style?.Border?.BorderWidth?.top}px ${Style?.Border?.BorderWidth?.right}px ${Style?.Border?.BorderWidth?.bottom}px ${Style?.Border?.BorderWidth?.left}px`,
                              borderRadius: `${Style?.Border.BorderRadius}px`,
                            }
                            : {}
                        }
                      >
                        {buttonText}
                      </button>
                    );
                  }
                })()}
              </div>
            </>
          );
        },
      },

      ProgressBar: {
        render: ({
          value,
          minValue,
          maxValue,
          barColor,
          height,
          ariaLabel,
          puck,
        }) => {
          const percentage = ((value - minValue) / (maxValue - minValue)) * 100;
          const clampedPercentage = Math.min(Math.max(percentage, 0), 100);

          const progressBarStyle = {
            width: `${clampedPercentage}%`,
          };
          if (barColor) {
            progressBarStyle.backgroundColor = barColor;
          }

          const progressContainerStyle = {};
          if (typeof height === "number") {
            // Check if height is a number
            progressContainerStyle.height = `${height}px`; // Append 'px'
          }

          return (
            <div
              className="progress"
              role="progressbar"
              aria-label={ariaLabel || "Progress bar"}
              aria-valuenow={value}
              aria-valuemin={minValue}
              aria-valuemax={maxValue}
              style={progressContainerStyle}
            >
              <div
                className="roi-progress-bar progress-bar"
                style={progressBarStyle}
              >
                {/* Label is removed */}
              </div>
            </div>
          );
        },
      },
      // Button: {
      //     render: ({ Button, hide }) => {
      //         // Render nothing if hide is true
      //         if (hide) {
      //             return null;
      //         }

      //         // Calculate opacity based on hide value
      //         const inputOpacity = hide ? 0.5 : 1;

      //         return (
      //             <>
      //                 <div className="button-wrap" style={{ opacity: inputOpacity }}>
      //                     {Button.buttonicon === "yes" ?

      //                         <button className={`d-inline-flex align-items-center btn roi-btn-${Button.buttonStyle}`} type="submit"><span className='with-icon'>{Button.buttonText}</span>
      //                             <div className="icon">
      //                                 <Svg name="roi-button-icon" />
      //                             </div>
      //                         </button>
      //                         :
      //                         <button className={`btn roi-btn-${Button.buttonStyle}`} type="submit">{Button.buttonText}</button>
      //                     }

      //                 </div>
      //             </>
      //         )

      //     },
      // },

      //Report
      ReportPage: {
        render: ({ Heading, Description, Padding, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <div className="heading-currency-wrapper d-lg-flex mb-3 mb-lg-4 align-items-center">
                    <div className="curecny-dropdown mb-3 mb-lg-0 order-2">
                      <select
                        className="form-control form-select"
                        onChange={(e) => currencyChange(e)}
                      >
                        <option
                          value={defaultCurrency}
                          selected={
                            changedCurrency == "" ||
                              changedCurrency == defaultCurrency
                              ? "selected"
                              : ""
                          }
                        >
                          {defaultCurrency}
                        </option>
                        {currency.map((item, i) => (
                          <option
                            value={item}
                            selected={changedCurrency == item ? "selected" : ""}
                            key={i}
                          >
                            {item}
                          </option>
                        ))}
                      </select>
                    </div>
                    <div className="section-heading flex-grow-1 order-1">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>
                  </div>
                  <div className="stats-section stats-section-custom">
                    <div className="row">
                      <div className="col-lg-8 mb-3 mb-lg-0">
                        <div className="total-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="total-wrapper" />
                        </div>
                        <div className="chart-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="chart-wrapper" />
                        </div>
                        <div className="custom-table-wrapper report-accordion-wrapper report-pg-table mb-3 mb-lg-4">
                          <DropZone zone="table-wrapper" />
                        </div>
                      </div>
                      <div className="col-lg-4">
                        <div className="download-wrapper-custom mb-3 mb-lg-4">
                          <DropZone zone="download-wrapper" />
                        </div>
                        <div className="card-wrapper-custom">
                          <DropZone zone="card-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      CardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-3" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value1),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {CurrencyFormatter({
                                amount: parseFloat(item.Value2),
                              })}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle3}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value3}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-none align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle4}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value4}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a
                            data-bs-toggle="modal"
                            data-bs-target="#reportModal"
                            onClick={() => onButtonClick(item.uuid)}
                            className="fs-16 fw-700"
                          >
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },

      ResultCard: {
        render: ({ Card1, Card2, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="total-wrapper" style={{ opacity: inputOpacity }}>
                <div className="total-inner bg-1">
                  <h5 className="fs-16 fw-700">{Card1.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card1.value) })}
                  </p>
                </div>
                <div className="total-inner bg-2">
                  <h5 className="fs-16 fw-700">{Card2.title}</h5>
                  <p className="fs-36 fw-300">
                    {CurrencyFormatter({ amount: parseFloat(Card2.value) })}
                  </p>
                </div>
              </div>
            </>
          );
        },
      },

      ChartCard: {
        render: ({ Heading, hide, Chart1, Chart2, Chart3, Chart4 }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="stat-wrap" style={{ opacity: inputOpacity }}>
                <div className="stat-heading">
                  <div className="icon d-none">
                    <img src={Heading.icon} alt="" />
                  </div>
                  <div
                    className={`text ${Heading.fontWeight} ${Heading.titleFont}`}
                  >
                    {Heading.title}
                  </div>

                  <div className="switch-btn">
                    <div className="switch-nav">
                      <input
                        id="microsoft"
                        type="radio"
                        name="company"
                        value="microsoft"
                        checked={selectedCompany === "microsoft"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="microsoft">Microsoft</label>

                      <input
                        id="vbuc"
                        type="radio"
                        name="company"
                        value="vbuc"
                        checked={selectedCompany === "vbuc"}
                        onChange={handleCompanyChange}
                      />
                      <label htmlFor="vbuc">VBUC</label>
                    </div>

                    <div className="switch-nav">
                      <input
                        id="year1"
                        type="radio"
                        name="year"
                        value="year1"
                        checked={selectedYear === "year1"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year1"> First Year</label>

                      <input
                        id="year3"
                        type="radio"
                        name="year"
                        value="year3"
                        checked={selectedYear === "year3"}
                        onChange={handleYearChange}
                      />
                      <label htmlFor="year3">Three Years </label>
                    </div>
                  </div>
                </div>

                <div className="stat-content-wrapper pt-4">
                  {selectedCompany === "vbuc" && selectedYear === "year1" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart1.items)}
                    />
                  )}
                  {selectedCompany === "vbuc" && selectedYear === "year3" && (
                    <ReactEcharts
                      style={chartStyle}
                      option={pieChart(Chart2.items)}
                    />
                  )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year1" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart3.items)}
                      />
                    )}

                  {selectedCompany === "microsoft" &&
                    selectedYear === "year3" && (
                      <ReactEcharts
                        style={chartStyle}
                        option={pieChart(Chart4.items)}
                      />
                    )}
                </div>
              </div>
            </>
          );
        },
      },


      //Report Single page

      ReportSection: {
        render: ({ Heading, Description, Padding, items, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                style={{ opacity: inputOpacity }}
              >
                <div className="container position-relative">
                  <DropZone zone={`summary-heading`} />
                  <div className="row">
                    <div className="col-xl-3 col-lg-4">
                      <DropZone zone={`summary-details`} />
                    </div>
                    <div className="col-xl-9 col-lg-8">
                      <div className="report-accordion-wrapper">
                        <ul className="nav nav-tabs" id="myTab" role="tablist">
                          {items.map((item, i) => (
                            <li
                              className="nav-item"
                              role="presentation"
                              key={i}
                            >
                              {/** Add Class 'filled' and active class will move to next <li> button once form is filled, this will add gray backround**/}
                              <button
                                className={
                                  item.isActive === true
                                    ? "nav-link active"
                                    : "nav-link"
                                }
                                onClick={() => openPopup(item.buttonValue)}
                              >
                                {item.Title}
                              </button>
                            </li>
                          ))}
                        </ul>
                        <div className="form-wrapper">
                          {/* <div className="tab-content" id="myTabContent"> */}
                          {/* {items.map((item, i) => ( */}
                          {/* <div className={i === 0 ? 'tab-pane fade show active' : 'tab-pane fade'} id={`tab-${i}-pane`} role="tabpanel" aria-labelledby={`tab-${i}`} tabIndex={0}> */}

                          <div className="form-inner">
                            <DropZone
                              zone={`wizard-form-wrapper`}
                              disallow={["SinglePage", "WizardForm"]}
                            />
                          </div>
                          {/* </div> */}
                          {/* ))} */}
                          {/* </div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      ReportTable: {
        render: ({
          Heading,
          Table,
          Headings,
          ColumnSettings,
          items,
          Calculations,
          Test,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="accordion-item" style={{ opacity: inputOpacity }}>
                {Heading?.title && (
                  <h2 className="fs-20 fw-700 accordion-button">
                    {Heading.title}
                  </h2>
                )}

                <div className="accordion-body report-accordion-wrapper">
                  <div className="table-wrapper">
                    <div className="table-responsive">
                      <table className="table">
                        {Table.FirstRow && (
                          <thead>
                            <tr>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FirstColSpan}'px'`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {Headings.Cell1}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.SecondColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell2}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.ThirdColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell3}
                              </th>
                              <th
                                scope="col"
                                style={{
                                  width: `${ColumnSettings.FourthColSpan}px`,
                                }}
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {Headings.Cell4}
                              </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {items.map((item, i) => (
                            <tr
                              key={i}
                              className={`${Table.LastRow && `table-last-row`}`}
                            >
                              <td
                                className={`${ColumnSettings.HighlightCol === "1st"
                                  ? "highlighted"
                                  : ""
                                  }`}
                              >
                                {item.Cell1isEditable ? (
                                  <input
                                    type="text"
                                    className="form-control first-column"
                                    defaultValue={item.Cell1Data}
                                  />
                                ) : (
                                  item.Cell1Data
                                )}
                              </td>

                              <td
                                className={`${ColumnSettings.HighlightCol === "2nd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "percentage"
                                  ) {
                                    return item.Cell2Data + "%";
                                  } else if (
                                    !item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell2Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell2Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell2uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell2isEditable &&
                                    item.Cell2EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell2Data}
                                        onBlur={(e) =>
                                          handleChange(item.Cell2uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell2Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "3rd"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "percentage"
                                  ) {
                                    return item.Cell3Data + "%";
                                  } else if (
                                    !item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell3Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell3Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell3uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell3isEditable &&
                                    item.Cell3EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell3Data}
                                        onBlur={(e) =>
                                          handleChange(item.Cell3uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell3Data;
                                  }
                                })()}
                              </td>
                              <td
                                className={`${ColumnSettings.HighlightCol === "4th"
                                  ? "highlighted"
                                  : ""
                                  } text-end`}
                              >
                                {(() => {
                                  if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                        >
                                          %
                                        </span>
                                      </div>
                                    );
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "percentage"
                                  ) {
                                    return item.Cell4Data + "%";
                                  } else if (
                                    !item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <>
                                        {CurrencyFormatter({
                                          amount: parseFloat(item.Cell4Data),
                                        })}
                                      </>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "currency"
                                  ) {
                                    return (
                                      <div className="input-group">
                                        <input
                                          type="text"
                                          className="form-control"
                                          aria-describedby="basic-addon2"
                                          defaultValue={item.Cell4Data}
                                          onBlur={(e) =>
                                            handleChange(item.Cell4uuid, e)
                                          }
                                        />
                                        <span
                                          className="input-group-text"
                                          id="basic-addon2"
                                          dangerouslySetInnerHTML={{
                                            __html: currencySymbol,
                                          }}
                                        ></span>
                                      </div>
                                    );
                                  } else if (
                                    item.Cell4isEditable &&
                                    item.Cell4EditStyle === "number"
                                  ) {
                                    return (
                                      <input
                                        type="text"
                                        className="form-control"
                                        aria-describedby="basic-addon2"
                                        defaultValue={item.Cell4Data}
                                        onBlur={(e) =>
                                          handleChange(item.Cell4uuid, e)
                                        }
                                      />
                                    );
                                  } else {
                                    return item.Cell4Data;
                                  }
                                })()}
                              </td>
                            </tr>
                          ))}
                        </tbody>
                        {/* {Table.LastRow && <tfoot>
                                                    <tr>
                                                        <td className='total fs-16 fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>{Calculations.Cell1}</td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td style={{ backgroundColor: '#333333', color: '#ffffff' }}></td>
                                                        <td className='fs-20 text-end fw-700' style={{ backgroundColor: '#333333', color: '#ffffff' }}>£{Calculations.Cell2}</td>
                                                    </tr>
                                                </tfoot>} */}
                      </table>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      // Download Report
      DownloadReportBanner: {
        render: ({
          Heading,
          Description,
          Padding,
          logo,
          image,
          backgroundImage,
          hide,
        }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`style3 dwn-report-section roi-banner-section position-relative ${Padding.bottom
                    } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                  style={{
                    backgroundImage: `url("${backgroundImage}")`,
                    backgroundPosition: "center",
                    backgroundSize: "cover",
                    backgroundRepeat: "no-repeat",
                  }}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="row align-items-center ">
                      <div className="col-lg-12">
                        <div className="banner-text">
                          <h1
                            className={`heading ${Heading.fontWeight} ${Heading.titleFont} mb-3`}
                          >
                            {Heading.title}
                          </h1>

                          <div className="text-part">
                            <div
                              className={Description.descriptionFont}
                              dangerouslySetInnerHTML={{
                                __html: Description.text,
                              }}
                            ></div>
                          </div>
                        </div>
                      </div>

                      <div className="col-lg-12">
                        <div className="img-wrapper">
                          <img src={image} className="img-fluid" alt="" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },
      DownloadReportPage: {
        render: ({ Heading, Description, Padding, logo, hide }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="portrait-report-wrapper"
                style={{ opacity: inputOpacity }}
              >
                <div
                  className={`dwn-report-section roi-reports-section position-relative ${Padding.bottom} ${Padding.top}`}
                >
                  <div className="container position-relative">
                    <div className="logo-wrap">
                      <Link to="">
                        <img src={logo} alt="" />
                      </Link>
                    </div>
                    <div className="section-heading mb-3 mb-md-4">
                      <h2
                        className={`heading ${Heading.fontWeight} ${Heading.titleFont}`}
                      >
                        {Heading.title}
                      </h2>
                      <p className={Description.Font}>{Description.text}</p>
                    </div>

                    <div className="stats-section">
                      <div className="row">
                        <div className="col-lg-12 mb-2">
                          <DropZone zone="card-wrapper" />
                        </div>

                        <div className="col-lg-12 mb-2">
                          <DropZone zone="total-wrapper" />
                        </div>

                        <div className="col-lg-12">
                          <DropZone zone="chart-wrapper" />
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      DownloadCardSection: {
        render: ({ items, hide, Text }) => {
          // Render nothing if hide is true
          if (hide) {
            return null;
          }

          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div className="row gx-2" style={{ opacity: inputOpacity }}>
                {items.map((item, i) => (
                  <div className="col-lg-4 col-md-4 mb-2" key={i}>
                    <div className="stat-wrap">
                      <div className="stat-heading">
                        <div className="icon">
                          <img src={item.icon} alt="" />
                        </div>
                        <div
                          className={`text ${Text.titleFont} ${Text.fontWeight}`}
                        >
                          {item.Title}
                        </div>
                      </div>
                      <div className="stat-content-wrapper d-flex flex-column">
                        <div className="d-flex flex-column flex-grow-1">
                          <div className="value-section value-section-1 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle1}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value1}
                            </div>
                          </div>
                          <div className="value-section value-section-2 d-flex align-items-center">
                            <div
                              className={`title ${Text.ValueTitleFont} ${Text.ValueTitleWeight}`}
                            >
                              {item.ValueTitle2}
                            </div>
                            <div
                              className={`flex-grow-1 value ${Text.ValueFont} ${Text.ValueWeight}`}
                            >
                              {item.Value2}
                            </div>
                          </div>
                        </div>
                        <div className="action">
                          <a href="" className="fs-16 fw-700">
                            {item.ActionText}{" "}
                            <span className="icon">
                              <svg
                                width={20}
                                height={20}
                                viewBox="0 0 20 20"
                                fill="none"
                                xmlns="http://www.w3.org/2000/svg"
                              >
                                <circle cx={10} cy={10} r={10} fill="#E60000" />
                                <path
                                  d="M8.18213 14.5453L12.7276 9.99983L8.18213 5.45438"
                                  stroke="white"
                                  strokeLinecap="round"
                                  strokeLinejoin="round"
                                />
                              </svg>
                            </span>
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </>
          );
        },
      },





      // Landing Page components

      TransparentSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`landing-page-cpmponent ${Style.CustomClass} component-section ${Padding.bottom
                  } ${Padding.top} ${Padding.fullHeight && "full-height"}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      GradientSection: {
        render: ({ Padding, Style }) => {
          return (
            <>
              <div
                className={`component-section gradient-bg ${Padding.bottom} ${Padding.top
                  } ${Padding.fullHeight && "full-height"}`}
              >
                {/* <div className='overlay'></div> */}
                <div className={`${Style.Width} position-relative`}>
                  <DropZone zone="section" />
                </div>
              </div>
            </>
          );
        },
      },

      Columns: {
        render: ({
          columns,
          distribution,
          vertical,
          gap,
          Padding,
          Style,
          Border,
        }) => {
          return (
            <div
              className={`d-grid section-column ${vertical}`}
              style={{
                backgroundImage: `url("${Style?.Background}")`,
                backgroundColor: `${Style?.BackgroundColor}`,
                backgroundPosition: "center",
                backgroundSize: "cover",
                padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,

                borderStyle: Border?.BorderStyle,
                borderColor: Border?.BorderColor,
                borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                borderRadius: `${Border?.BorderRadius}px`,

                gridTemplateColumns:
                  distribution === "manual"
                    ? "repeat(12, 1fr)"
                    : `repeat(${columns.length}, 1fr)`,
                gridColumnGap: `${gap}px`,
              }}
            >
              {columns.map(({ span, backgroundColor }, idx) => (
                <div
                  key={idx}
                  className="w-100"
                  style={{
                    display: "flex",
                    backgroundColor: backgroundColor,
                    flexDirection: "column",
                    gridColumn:
                      span && distribution === "manual"
                        ? `span ${Math.max(Math.min(span, 12), 1)}`
                        : "",
                  }}
                >
                  <DropZone
                    zone={`column-${idx}`}
                  // disallow={["Section"]}
                  />
                </div>
              ))}
            </div>
          );
        },
      },

      Wrapper: {
        render: ({ Padding, Style, Border, customClass, hide, uuid }) => {
          if (hide == true || hide == 'true') {
            return null;
          }
          return (
            <>
              <div
                className={`component-wrapper ${customClass}`}
                style={{
                  backgroundImage: `url("${Style.Background}")`,
                  backgroundColor: `${Style.BackgroundColor}`,
                  backgroundPosition: "center",
                  backgroundSize: "cover",
                  padding: `${Padding.top}px ${Padding.right}px ${Padding.bottom}px ${Padding.left}px`,

                  borderStyle: Border.BorderStyle,
                  borderColor: Border.BorderColor,
                  borderWidth: `${Border?.BorderWidth?.top}px ${Border?.BorderWidth?.right}px ${Border?.BorderWidth?.bottom}px ${Border?.BorderWidth?.left}px`,
                  borderRadius: `${Border.BorderRadius}px`,
                }}
              >
                {/* <div className='overlay'></div> */}
                <div className={`position-relative`}>
                  <DropZone zone="wrapper" />
                </div>
              </div>
            </>
          );
        },
      },

      Spacing: {
        render: ({ Height }) => {
          return <div style={{ height: `${Height}` }}></div>;
        },
      },

      Heading: {
        render: ({ Text, Padding }) => {
          return (
            <>
              {(() => {
                if (Text.tag === "h1") {
                  return (
                    <h1
                      className={`section-title m-0 size-h1 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h1>
                  );
                } else if (Text.tag === "h2") {
                  return (
                    <h2
                      className={`section-title m-0 size-h2 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h2>
                  );
                } else if (Text.tag === "h3") {
                  return (
                    <h3
                      className={`section-title m-0 size-h3 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h3>
                  );
                } else if (Text.tag === "h4") {
                  return (
                    <h4
                      className={`section-title m-0 size-h4 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h4>
                  );
                } else if (Text.tag === "h5") {
                  return (
                    <h5
                      className={`section-title m-0 size-h5 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h5>
                  );
                } else if (Text.tag === "h6") {
                  return (
                    <h6
                      className={`section-title m-0 size-h6 ${Text.fontWeight} ${Text.titleFont}`}
                      style={{
                        color: `${Text.Color}`,
                        textAlign: Text.Align,
                        padding: `${Padding?.top}px ${Padding?.right}px ${Padding?.bottom}px ${Padding?.left}px`,
                      }}
                    >
                      <div
                        dangerouslySetInnerHTML={{ __html: Text.title }}
                      ></div>
                    </h6>
                  );
                }
              })()}
            </>
          );
        },
      },

      Text: {
        render: ({ Text }) => {
          return (
            <>
              <div
                style={{
                  color: `${Text.Color}`,
                  textAlign: Text.Align,
                }}
                className={`section-text m-0 ${Text.FontWeight} ${Text.FontSize}`}
                dangerouslySetInnerHTML={{ __html: Text.text }}
              ></div>
            </>
          );
        },
      },

      Image: {
        render: ({ Image, AspectRatio, fullWidth }) => {
          return (
            <>
              <div className="image-wrapper">
                <img
                  src={Image}
                  alt=""
                  className={`img-fluid object-cover ${fullWidth && `w-100`} `}
                  style={{ aspectRatio: `${AspectRatio}` }}
                />
              </div>
            </>
          );
        },
      },

      RedCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-1">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      WhiteCards: {
        render: ({ Lists, Settings }) => {
          return (
            <>
              <div className="roi-cards-section card-layout-2">
                <div className="cards-wrapper">
                  <div className="row justify-content-center">
                    {Lists.map((list, i) => (
                      <div className="col-lg-4 col-md-6 mb-3" key={i}>
                        <input
                          className="form-check-input d-none"
                          type="radio"
                          name={Settings.Card.UniqueID}
                          id={`${Settings.Card.UniqueID}-${i}`}
                        />
                        <label
                          className="card-outer"
                          htmlFor={`${Settings.Card.UniqueID}-${i}`}
                          style={{
                            borderStyle: Settings.Border.BorderStyle,
                            borderColor: Settings.Border.BorderColor,
                            borderWidth: `${Settings.Border.BorderWidth}px`,
                            borderRadius: `${Settings.Border.BorderRadius}px`,
                            backgroundColor: Settings.Card.BackgroundColor,
                            paddingTop: `${Settings.Card.Padding.top}px`,
                            paddingRight: `${Settings.Card.Padding.right}px`,
                            paddingBottom: `${Settings.Card.Padding.bottom}px`,
                            paddingLeft: `${Settings.Card.Padding.left}px`,
                            textAlign: Settings.Text.Align,
                          }}
                        >
                          <div className="card-inner">
                            {list.Image ? (
                              <div class="icon-wrapper">
                                <img
                                  src={list.Image}
                                  alt=""
                                  height={Settings.Card.IconSize}
                                  width={Settings.Card.IconSize}
                                />
                              </div>
                            ) : (
                              ""
                            )}
                            <div className="text-wrapper">
                              <h4
                                className={`${Settings.Text.TitleFont} ${Settings.Text.TitleFontWeight}`}
                                style={{ color: Settings.Text.TitleColor }}
                              >
                                {list.Title}
                              </h4>
                              <p
                                className={`${Settings.Text.DescriptionFont} ${Settings.Text.DescriptionFontWeight} mb-0`}
                                style={{
                                  color: Settings.Text.DescriptionColor,
                                }}
                              >
                                {list.Description}
                              </p>
                            </div>
                            <div className="button-wrapper">
                              <button className="btn btn-action">
                                <Svg name="roi-card-button" />
                              </button>
                            </div>
                          </div>
                        </label>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
            </>
          );
        },
      },

      PieChart: {
        render: ({ chartOption }) => (
          <>
            <div className="echart-wrapper">
              <ReactEcharts
                style={{
                  height: "200px",
                  width: "100%",
                }}
                option={chartOption}
              />
            </div>
          </>
        ),
      },

      eCharts: {
        render: ({ Chart, hide }) => {
          const inputOpacity = hide ? 0.5 : 1;

          const PieChartStyle = {
            height: "330px",
            width: "100%",
          };

          const BarChartStyle = {
            height: "206px",
            width: "100%",
          };

          return (
            <>
              <div className="echart-wrap" style={{ opacity: inputOpacity }}>
                {(() => {
                  if (Chart.chooseChart === "pie") {
                    return (
                      <ReactEcharts
                        style={PieChartStyle}
                        option={pieEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  } else if (Chart.chooseChart === "bar") {
                    return (
                      <ReactEcharts
                        style={BarChartStyle}
                        option={barEChart(Chart.items, Chart.title, Chart.value)}
                      />
                    );
                  }
                  return null;
                })()}
              </div>
            </>
          );
        },
      },

      ToggleSwitch: {
        render: ({ items, ID, hide, Margin, Style }) => {
          // Calculate opacity based on hide value
          const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className={`roi-form-group ${Style?.customMargin ? "" : "mb-3"
                  } position-relative d-flex align-items-center ${Style?.Alignment
                  }`}
                style={{
                  opacity: inputOpacity,
                  margin: `${Margin?.top}px ${Margin?.right}px ${Margin?.bottom}px ${Margin?.left}px`,
                }}
              >
                <div
                  className={`roi-toggle-switch d-flex align-items-center`}
                  style={{
                    borderStyle: "solid",
                    borderColor: "#B6B7B8",
                    borderWidth: `1px 1px 1px 1px`,
                    borderRadius: `4px`,
                  }}
                >
                  {items.map((item, i) => (
                    <div className="form-check" key={i}>
                      <input
                        className="form-check-input"
                        name={ID}
                        type="radio"
                        defaultValue
                        id={`${ID}-${i}`}
                      />
                      <label
                        className="form-check-label"
                        htmlFor={`${ID}-${i}`}
                      >
                        {item.Option}
                      </label>
                    </div>
                  ))}
                </div>
              </div>
            </>
          );
        },
      },

      Collapsible: {
        render: ({ ID }) => {
          // Calculate opacity based on hide value
          // const inputOpacity = hide ? 0.5 : 1;

          return (
            <>
              <div
                className="collapse-header collapsed"
                data-bs-toggle="collapse"
                href={`#${ID}`}
                role="button"
                aria-expanded="false"
                aria-controls={`${ID}`}
              >
                <DropZone zone={`collapse-header`} />
                <div className="drop-icon">
                  <Svg name="collapsible-icon" />
                </div>
              </div>

              <div className="collapse-body collapse" id={`${ID}`}>
                <DropZone zone={`collapse-body`} />
              </div>
            </>
          );
        },
      },

      Collapsible2: {
        render: function FrontendCollapsible({ itemId, headerText }) {
          // Props:
          // - itemId: The unique ID for this collapsible.
          // - headerText: The custom header text from admin, if provided.
          // - zones: Object containing content from DropZones (e.g., zones.content).

          const collapseRef = React.useRef(null);
          const buttonRef = React.useRef(null);

          // Function to determine the initial button text
          const getInitialButtonText = () => {
            if (headerText) {
              // If a specific header text is provided, always use it
              return headerText;
            }
            // Otherwise, default to "Show Details" as it starts collapsed on frontend
            return "Show Details";
          };

          const [currentButtonText, setCurrentButtonText] = React.useState(
            getInitialButtonText()
          );

          React.useEffect(() => {
            const collapsibleElement = collapseRef.current;
            const triggerButton = buttonRef.current;

            if (!collapsibleElement || !triggerButton) {
              return; // Exit if refs are not yet set
            }

            const updateTextBasedOnState = () => {
              if (headerText) {
                // If a specific headerText is provided, always use that
                setCurrentButtonText(headerText);
                return;
              }
              // Check if the collapsible element has the 'show' class (is open)
              if (collapsibleElement.classList.contains("show")) {
                setCurrentButtonText("Hide Details");
              } else {
                setCurrentButtonText("Show Details");
              }
            };

            // Bootstrap event listeners to update text after animations complete
            const handleShown = () => updateTextBasedOnState();
            const handleHidden = () => updateTextBasedOnState();

            collapsibleElement.addEventListener(
              "shown.bs.collapse",
              handleShown
            );
            collapsibleElement.addEventListener(
              "hidden.bs.collapse",
              handleHidden
            );

            // Initial text update in case the component mounts in an unexpected state
            // or if 'show' class was somehow added initially by other means.
            updateTextBasedOnState();

            // Cleanup: remove event listeners when the component unmounts or dependencies change
            return () => {
              collapsibleElement.removeEventListener(
                "shown.bs.collapse",
                handleShown
              );
              collapsibleElement.removeEventListener(
                "hidden.bs.collapse",
                handleHidden
              );
            };
          }, [itemId, headerText]); // Dependencies for the effect

          const collapseId = `collapse-${itemId}`; // Unique ID for the Bootstrap content div
          const headingId = `heading-${itemId}`; // Unique ID for the Bootstrap header

          // Frontend default: start collapsed. Bootstrap JS handles adding/removing 'show'.
          const collapseClasses = ["accordion-collapse", "collapse"];
          const initialAriaExpanded = "false";
          const initialButtonClassName = "accordion-button collapsed";

          return (
            <div className="accordion-item details-accordion">
              <h2 className="accordion-header" id={headingId}>
                <button
                  ref={buttonRef}
                  className={initialButtonClassName}
                  type="button"
                  data-bs-toggle="collapse"
                  data-bs-target={`#${collapseId}`}
                  aria-expanded={initialAriaExpanded}
                  aria-controls={collapseId}
                >
                  {currentButtonText}
                </button>
              </h2>
              <div
                ref={collapseRef}
                id={collapseId}
                className={collapseClasses.join(" ")}
                aria-labelledby={headingId}
              // If you implement accordion groups via a 'parentId' prop from admin:
              // data-bs-parent={props.parentId ? `#${props.parentId.replace(/^#/, '')}` : undefined}
              >
                <div className="accordion-body">
                  <DropZone zone="content" />
                </div>
              </div>
            </div>
          );
        },
      },

      IconUploader: {
        render: ({
          iconFile,
          iconFallbackUrl,
          iconWidth,
          iconHeight,
          puck,
        }) => {
          // Helper to prepare src for img tag (handles raw SVG and data URLs)
          const getDisplaySrc = (imgValue) => {
            if (
              typeof imgValue === "string" &&
              imgValue.trim().startsWith("<svg")
            ) {
              return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(
                imgValue
              )}`;
            }
            return imgValue; // Assumes it's already a data URL or external URL
          };

          const primarySrc = getDisplaySrc(iconFile);
          const fallbackSrc = getDisplaySrc(iconFallbackUrl); // Fallback could also be raw SVG

          const imgSrc = primarySrc || fallbackSrc;
          const displayWidth = iconWidth || 24;
          const displayHeight = iconHeight || 24;

          return (
            <div>
              {imgSrc ? (
                <img
                  src={imgSrc}
                  alt="Icon"
                  style={{
                    width: `${displayWidth}px`,
                    height: `${displayHeight}px`,
                    maxWidth: "100%",
                    maxHeight: "100%",
                    objectFit: "contain",
                    verticalAlign: "middle",
                  }}
                />
              ) : (
                puck &&
                puck.isEditing && (
                  <span style={{ fontSize: "10px", color: "#aaa" }}>
                    No Icon
                  </span>
                )
              )}
            </div>
          );
        },
      },

      Separator: {

        render: ({ color, height, margin }) => {
          return (
            <div className="separator" style={{ backgroundColor: color, height: `${height}px`, margin: `${margin?.top}px ${margin?.right}px ${margin?.bottom}px ${margin?.left}px` }}>

            </div>
          )
        },
      },

    },
  };

  useEffect(() => {
    getPagesList()
    getRoiDetail();
    //getPagesListName()
  }, [roiId])

  const getRoiDetail = async () => {
    const response = await performHttpRequest(
      "GET",
      `${apiUrl}/roi/getRoiDetail/${roiId}`,
      ""
    );
    setRoiName(response?.data?.result?.roi_name)
  }




  useEffect(() => {

    setGlobalRoiArr([]);
    processLogic();
    // }, [roiActionArr]);
  }, [roipages]);

  useEffect(() => {
    //console.log("exchange action triggered")
    // console.log("exchange roiActionArr", roiActionArr)
    if (globalRoiArr.length > 0) {
      //console.log("globalRoiArr action triggered")
      processLogic();
    }
  }, [globalRoiArr]);

  useEffect(() => {
    //console.log("pages triggered", currentPageId);
    // console.log('roipages[all]', roipages['54cfe3bb-6400-4f1c-a6eb-1370fd41e3fd'])
    if (currentPopupPageId !== '' && roipages[currentPopupPageId] !== undefined && popupStatus == true) {
      //console.log("Page_test");
      setRenderModalData(JSON.parse(roipages[currentPopupPageId]));
    }
    if (currentPageId !== '' && roipages[currentPageId] !== undefined) {
      setRenderData(JSON.parse(roipages[currentPageId]));
      // console.log('roipages[currentPageId]', roipages[currentPageId])
    }
  }, [roipages, currentPageId, currentPopupPageId]);


  const getPagesList = async () => {

    const response = await performHttpRequest(
      "GET",
      `${apiUrl}/roi-pages/detail/${roiId}`,
      ""
    );
    setPages(response?.data?.result)

    if (response?.data?.result?.length > 0) {
      const structure = response?.data?.result[1]?.structure;
      // if (editorData == null) {
      // console.log("structure=====>", structure);

      if (structure) {
        try {
          const parsedStructure = JSON.parse(structure);
          //console.log('prasedStructure ', parsedStructure)
          setEditData(parsedStructure);
        } catch (error) {
          console.error("Failed to parse JSON structure:", error);
        }
      } else {
        console.error("Structure is empty or null.");
      }

      setEditData(JSON?.parse(structure));
      setCurrentReportId(response?.data?.result[0]?.roi_page_id)
    }

    const resultarray = response?.data?.result;
    const reportPages = resultarray.filter(item => item.roi_template_type_id === 6 && item.is_active === 1);
    const onlyStructure = reportPages.map(item => JSON.parse(item.structure));


    // console.log('reponse', reportPages)
    // console.log('onlystructure====', onlyStructure)
    setroipageshow(onlyStructure);
    setReportPages(reportPages)
    setIsLoading(false)

  }

  const pieChartData2 = [];

  function updateValuesreport(objectsArray, newValuesObject) {
    const formatNumberForDisplay = (value) => {
      if (value === undefined || value === null) {
        return value;
      }

      const toNumber = (val) => {
        const num = Number(val);
        return Number.isFinite(num) ? num : null;
      };

      const formatWithDecimals = (num, decimals) =>
        num.toLocaleString('en-US', {
          minimumFractionDigits: decimals,
          maximumFractionDigits: decimals,
        });

      if (typeof value === 'number') {
        if (!Number.isFinite(value)) {
          return value;
        }
        if (Number.isInteger(value)) {
          return value.toLocaleString('en-US');
        }
        return value.toLocaleString('en-US');
      }

      if (typeof value === 'string') {
        const trimmed = value.trim();
        if (!trimmed) {
          return value;
        }

        const numericCandidate = trimmed.replace(/,/g, '');
        const parsed = toNumber(numericCandidate);
        if (parsed === null) {
          return value;
        }

        const decimalIndex = numericCandidate.indexOf('.');
        if (decimalIndex === -1) {
          return parsed.toLocaleString('en-US');
        }

        const decimalPart = numericCandidate.slice(decimalIndex + 1);
        if (decimalPart.replace(/0+$/, '').length === 0) {
          return parsed.toLocaleString('en-US');
        }

        const decimalPlaces = decimalPart.length;
        return formatWithDecimals(parsed, decimalPlaces);
      }

      const coerced = toNumber(value);
      if (coerced !== null) {
        if (Number.isInteger(coerced)) {
          return coerced.toLocaleString('en-US');
        }
        return coerced.toLocaleString('en-US');
      }

      return value;
    };

    objectsArray.forEach((obj, pageIndex) => {
      // Iterate over all zones in the object
      Object.keys(obj.zones).forEach(zoneKey => {
        const zoneArray = obj.zones[zoneKey];


        // Check each item in the zone array
        zoneArray.forEach(item => {
          // Handling the previous uuid-based update
          if (item?.props?.uuid) {
            const uuid = item.props.uuid;
            if (uuid && newValuesObject[uuid]) {
              //console.log('previous value (uuid)', item.props.value);
              // Apply the three decimal filter
              item.props.value = formatNumberForDisplay(newValuesObject[uuid].value);
              //console.log('updated value (uuid)', item.props.value);

              if (item.type === 'Heading') {
                item.props.Text.title = parseFloat(newValuesObject[uuid].value).toFixed(0).replace(/\.?0+$/, '') + 'x';
              }
            }
          }

          // Handle Text components with inline dynamic spans
          if (item.type === 'Text' && item?.props?.Text?.text) {
            try {
              const ParserCtor =
                (typeof window !== 'undefined' && window.DOMParser)
                  ? window.DOMParser
                  : (typeof DOMParser !== 'undefined' ? DOMParser : null);
              if (ParserCtor) {
                const parser = new ParserCtor();
                const doc = parser.parseFromString(item.props.Text.text, 'text/html');
                const spanNodes = doc.querySelectorAll('span[uuid]');
                spanNodes.forEach((span) => {
                  const uuid = span.getAttribute('uuid');
                  const match = newValuesObject[uuid];
                  if (match && match.value !== undefined && match.value !== null) {
                    const rawVal = match.value;
                    const formattedMain = formatNumberForDisplay(rawVal);

                    // Try to compute a rounded (0‑decimal) variant
                    let roundedText = '';
                    const num = Number(String(rawVal).toString().replace(/,/g, ''));
                    if (Number.isFinite(num)) {
                      const rounded = Math.round(num);
                      roundedText = formatNumberForDisplay(rounded);
                    }

                    // On page 1 (index 0) use the original formatted value only.
                    // On subsequent report pages, use the rounded value when available.
                    if (pageIndex === 0) {
                      span.textContent = formattedMain;
                    } else {
                      span.textContent = roundedText || formattedMain;
                    }
                  }
                });
                item.props.Text.text = doc.body.innerHTML;
              }
            } catch (spanError) {
              console.error('[ROIReportSubmitted] Failed to update dynamic span text', spanError);
            }
          }

          // Handle eCharts typemm
          if (item.type === 'eCharts') {

            const pieChartData_1 = [];

            // Iterate over each item in eCharts
            item.props.Chart.items.forEach(row => {
              const rowUuid = row.uuid;
              // Ensure that the UUID exists and the value from newValuesObject is valid
              if (rowUuid && newValuesObject[rowUuid] && newValuesObject[rowUuid].value !== undefined) {
                const data = {
                  value: newValuesObject[rowUuid].value || 0,
                  Text: row.Text,
                  Color: row.Color
                };
                pieChartData_1.push(data);

                //console.log(` ${row.Text} (uuid: ${rowUuid}) ${newValuesObject[rowUuid].value}`);
              } else {
                //console.log(`Missing or invalid value for ${row.Text} (uuid: ${rowUuid})`);
              }
            });

            //console.log("Pie chart data:", pieChartData_1);
            pieChartData2.push(pieChartData_1)



            // No need to split the data anymore, use all 6 values
            if (pieChartData_1.length === 6) {
              //console.log("Full Pie chart data:", pieChartData);
            } else {
              //console.log(`Warning: Expected 6 values for pie chart, but got ${pieChartData_1.length}`);
            }
          }

          // Check if item is of type 'ReportTable'
          if (item.type === 'ReportTable') {
            // Iterate over 'items' array inside 'ReportTable'
            item.props.items.forEach(row => {
              // Iterate over the cells with uuids
              ['Cell1uuid', 'Cell2uuid', 'Cell3uuid', 'Cell4uuid'].forEach(cellUuidKey => {
                const cellUuid = row[cellUuidKey];
                if (cellUuid && newValuesObject[cellUuid]) {
                  // Determine which CellData to update based on the uuid key
                  const cellDataKey = cellUuidKey.replace('uuid', 'Data');
                  // console.log(`previous value (${cellUuidKey})`, row[cellDataKey]);
                  // Apply the three decimal filter
                  row[cellDataKey] = parseFloat(newValuesObject[cellUuid].value).toFixed(0)
                  // console.log(`updated value (${cellUuidKey})`, row[cellDataKey]);
                }
              });
            });
          }

        });
      });
    });
    const piechartdatavalue = pieChartData2.slice(0, 2);
    //console.log('piechartData datavalue',piechartdatavalue)
    PieChartData.current = piechartdatavalue;

    return objectsArray;
  }



  useEffect(() => {
    //console.log('update value=================>',updateValuesreport(roipageshow, PageActionArr));
    setReportrender(updateValuesreport(roipageshow, PageActionArr))
    //console.log('piechartData 2',pieChartData2)

  }, [roipageshow, PageActionArr])

  useEffect(() => {
    // Check if master ID exists in local storage
    const storedMasterId = localStorage.getItem('roi_master_id');
    if (storedMasterId) {
      // Master ID exists, add child data
      //console.log('Master ID exists:', storedMasterId);
      addChildData(storedMasterId);
    } else {
      // Master ID does not exist, insert master data, add child data, and store master ID in local storage
      //console.log('Master ID does not exist. Inserting master data...');
      insertMasterData(masterId).then((newMasterId) => {
        //console.log('New Master ID inserted:', newMasterId);
        localStorage.setItem('roi_master_id', newMasterId);
        addChildData(newMasterId);
      });
    }
  }, []);

  const addChildData = (masterId) => {
    // Function to add child data with the given master ID
    //console.log('Adding child data with master ID:', masterId);
    // Add your logic to add child data here
  };

  const insertMasterData = async (masterId) => {
    // Function to insert master data and return the master ID
    //console.log('Inserting master data with ID:', masterId);
    // Add your logic to insert master data here
    // Return the master ID (simulated with a Promise for this example)
    return new Promise((resolve) => {
      setTimeout(() => {
        resolve(masterId); // Simulate an API call that returns the master ID
      }, 1000);
    });
  };

  if (isLoading) {
    return <div>Loading...</div>;
  }


  return (
    <>

      {<div className="page-wrapper" id='surveyReport'>
        {(() => {
          // Check the condition for the specific uuid
          let pagesToRender = reportrender;

          const pageValue = PageActionArr['6193890c-b349-4a33-afcc-3a5b9b59997e']?.value;
          if ((pageValue === 1 || pageValue === "1") && reportrender.length > 1) {
            pagesToRender = reportrender.slice(0, -1);
          }

          console.log("pagesToRender", pagesToRender);
          return pagesToRender.map((page, index) => {
            return (
              <Render key={index} config={config} data={page} />
            );
          });
        })()}
      </div>}

      {/* <Render config={config} data={renderData} /> */}
    </>
  );
};

export default StoreROI;